import React from 'react';
import Filters from '../../../components/Filters';
import GrayCard from '../../../components/vendorCard';
import _get from 'lodash/get';
import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';
import Modal from '../../../components/Modal';
import C3Chart from 'react-c3js';
// import 'c3/c3.css';
import Select from 'react-select';
import './Dashboard.css';
import Axios from 'axios';
import { getMemberPurchasesData, ROOT_URL } from '../../../actions';
import { Checkbox, TextArea } from 'semantic-ui-react'
import {
    getVendorSalesRebatCardData, getDashboardSalesOpportunityGraph, getVendorOverviewRebateNameFiltered, getVendorOverviewSourceNamesFiltered, getVendorOverviewVendorPartnerVolume, getDashboardOverallSalesAndRebate,
    getDashboardRebatesOverview, getRebateViewMemberVendorRebateData, getDashboardSalesOpportunityByMember,
    getDashboardSalesOpportunityByRegion, getDashboardGrowthRebate, getDashboardSalesOpportunityByBusiness,
    getStateRegions, getStateToStateMapping, getVendorOpportunityByCategoryData, saveProductFeedback,
    getProductListVendorDashboard, getProductCategorycorporate, getVendorMonthsFilter, getDashboardIndividualGrowthRebate,
    getVendorOverviewBhNames, getVendorOverviewSourceNames, getVendorOverviewRebateName,
    regionCodeNameMapping, tabTracking, getMemberPurchasesDataa, getMemberList,getMemberVendorDate
} from '../../../actions';
import { VectorMap } from 'react-jvectormap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    PriceFormatter,PriceFormatter2, dynamicDateFilters1, dynamicDateFilters, monthName1, monthName, PercentFormatter, PercentFormatter1, paramsToJSON1,
    getCardTitle, differenceFormatter, PriceFormatter1, DateFormatter, jsonToParam, paramsToJSON,
    formatCurrency,
    formatPounds, formatUnits
} from '../../../helper';
import accounting from 'accounting-js';
import _isEqual from 'lodash/isEqual';
import _cloneDeep from 'lodash/cloneDeep';
import _isEmpty from 'lodash/isEmpty';
import _max from 'lodash/max';
import _set from 'lodash/set';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Table from 'react-bootstrap/Table'
import { Dropdown } from 'semantic-ui-react';
import ReactExport from "react-export-excel";
import { matLoader } from '../../../components/Loader';
// import 'react-virtualized/styles.css';
import { Row, Col, Card, Form, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import swal from 'sweetalert';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'react-toastify/dist/ReactToastify.min.css';
import { Link } from 'react-router-dom';
import { Modelpopup } from '../../../components/ModelPopUp';

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function checkCookie(cname) {
    return getCookie(cname) && getCookie(cname) !== '';
}

// const members = [
//     { label: "All", value: "1" },
//     { label: "Member1", value: "00001" },
//     { label: "Member2", value: "00002" },
//     { label: "Member3", value: "00003" },
//     { label: "Member4", value: "00004" },
//     { label: "Member5", value: "00005" },
//     { label: "Member6", value: "00006" }
//   ];


class VendorDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            compliantvalue: false,
            selectedFilter: "YTD",
            buttonOptions: ["MTH", "YTD", "QTR"],
            showQuarter: false,
            dataval: [],
            items: [],
            selectedYear: new Date().getFullYear(),
            selectedItem: new Date().getMonth(),
            isLoading: true,
            filters: [{}],
            rebateOptions: [],
            selectedRebateType: "",
            rebateCardData: [],
            overallCardData: [],
            showProductListModal: false,
            showProductListModalPopUp: false,
            showPopUpForProductFedbackDetails: false,
            disableNewProductCategoryDropdown: true,
            addModalShow: false,
            // firstPopUp: false,
            firstPopUp: true,
            params: {
                period: "YTD",
                ytd: "true",
                qtr: "false",
                mth: "false",
                year: 2022,
                month: 12,
                quarter: 4,
                vendorId: this.props.vendorIdForCorporate,
                memberId: '',
                dropDown: [],
                startRowNo: 0,
            },
            scoreColumnsRows: [
                { "memberId": "00001", "memberName": "Member1", "Purchase": "10000", "Contribution": "4%", "Categories": 1, "SalesRank": "1", "CategoryRank": "1", "FinalRank": "2" },
                { "memberId": "00002", "memberName": "Member2", "Purchase": "16000", "Contribution": "12%", "Categories": 1, "SalesRank": "1", "CategoryRank": "1", "FinalRank": "2" },
                { "memberId": "00003", "memberName": "Member3", "Purchase": "17000", "Contribution": "19%", "Categories": 1, "SalesRank": "1", "CategoryRank": " 1", "FinalRank": "2" },
                { "memberId": "00004", "memberName": "Member4", "Purchase": "18000", "Contribution": "27%", "Categories": 2, "SalesRank": "2", "CategoryRank": "1 ", "FinalRank": "3" },
                { "memberId": "00005", "memberName": "Member5", "Purchase": "19000", "Contribution": "36%", "Categories": 2, "SalesRank": "2", "CategoryRank": "1 ", "FinalRank": "3" },
                { "memberId": "00006", "memberName": "Member6", "Purchase": "20000", "Contribution": "45%", "Categories": 3, "SalesRank": "3", "CategoryRank": " 2", "FinalRank": "5" },
                { "memberId": "00007", "memberName": "Member7", "Purchase": "24000", "Contribution": "55%", "Categories": 3, "SalesRank": "3", "CategoryRank": "2 ", "FinalRank": "5" },
                { "memberId": "00008", "memberName": "Member8", "Purchase": "25000", "Contribution": "67%", "Categories": 4, "SalesRank": "4", "CategoryRank": "2", "FinalRank": "6" },
                { "memberId": "00009", "memberName": "Member9", "Purchase": "35000", "Contribution": "82%", "Categories": 4, "SalesRank": "4", "CategoryRank": " 2", "FinalRank": "6" },
                { "memberId": "00010", "memberName": "Member10", "Purchase": "40000", "Contribution": "100%", "Categories": 5, "SalesRank": "5", "CategoryRank": "3 ", "FinalRank": "8" }],

            members: [
                { label: "All", value: "1" },
                { label: "Member1", value: "00001" },
                { label: "Member2", value: "00002" },
                { label: "Member3", value: "00003" },
                { label: "Member4", value: "00004" },
                { label: "Member5", value: "00005" },
                { label: "Member6", value: "00006" }
            ],


        }
        this.vectorMapRef = React.createRef();
    }

    renderDate() {
        
        let datacard = [];
        this.props.getVendorSalesRebatCardData.forEach((row,index) => {
            console.log("cardtitle",row.updateDate);
            //     datacard.push({
            //         ...row,
            //         cardTitle :row.cardTitle[index],
            //         updateDate:row.updateDate,
            // });
        if((row.cardTitle == "Vendor Total Sales") && (row.updateDate != '1970-01-01') && (row.updateDate != null)){
            return(<span>
                { row.updateDate}
                  </span>
            );
        }
        else {
            return (<div style={{ color: "blue" }} >NA</div>
            );
        }
        
    })
};

    handleUserSelectedFilter(option) {
        let obj = {};

        if (option === "qtr" || option === "QTR") {
            this.setState({ showQuarter: true });
        } else {
            this.setState({ showQuarter: false });
        }
        let paramsValues = this.state.params;
        let paramsfinal = paramsToJSON1(paramsValues);
        let month = paramsfinal.month;

        if (month >= 1 && month <= 3) {
            paramsfinal.quarter = 1
        }
        else if (month >= 4 && month <= 6) {
            paramsfinal.quarter = 2
        }
        else if (month >= 7 && month <= 9) {
            paramsfinal.quarter = 3
        }
        else if (month >= 10 && month <= 12) {
            paramsfinal.quarter = 4
        }

        let params = jsonToParam(paramsfinal);
        this.setState({ selectedFilter: option, params: params }, () => {
            this.setFilter({
                period: this.state.selectedFilter, memberId: this.props.memberId
            });
        });



    }
    colseModal = value => {
        // ;
        this.setState({ firstPopUp: false });
    };


    componentWillMount() {
        let paramsValues = this.state.params;
        let paramsfinal = dynamicDateFilters1(paramsValues);
        let params = jsonToParam(paramsfinal);

        console.log(params);
        this.setState({ params: params });

    }
    componentWillReceiveProps(props) {
        const { dataForChart } = this.state;
        let totalSalesOpportunity = props.salesOpportunity.chartData2;
        if (!_isEqual(dataForChart, props.salesOpportunity)) {
            let totalSales = totalSalesOpportunity[totalSalesOpportunity.length - 1];
            console.log(Number(totalSales).toFixed(2), typeof (totalSales));
            this.setState({
                totalSalesOpportunity: totalSalesOpportunity[totalSalesOpportunity.length - 1],
                dataForChart: {
                    data: {
                        columns: [
                            props.salesOpportunity.chartData1,
                            props.salesOpportunity.chartData2,
                            props.salesOpportunity.chartData3,
                        ],
                        axes: {

                        },
                        names: {
                            data1: "Verified Total Sales ($)",
                            data2: "Sales Opportunity ($)",
                            data3: "Supplier Total Sales ($)"
                        }
                    }
                }
            });
        }

        /*Added for member purchase graph on 02/06/2021*/

        // const { GraphdataForChart } = this.state;
        // let WholeGraphData= props.PurchasesGraphData.chartData2;
        // if (!_isEqual(GraphdataForChart, props.PurchasesGraphData)) {
        //     let totalSales = WholeGraphData[WholeGraphData.length - 1];
        //     this.setState({
        //         WholeGraphData: WholeGraphData[WholeGraphData.length - 1],
        //         GraphdataForChart: {
        //             data: {
        //                 columns: [
        //                     props.PurchasesGraphData.GraphchartData1,
        //                     props.PurchasesGraphData.GraphchartData2,
        //                     props.PurchasesGraphData.GraphchartData3,
        //                 ],
        //                 axes: {

        //                 },
        //                 names: {
        //                     data1: "Current Year Sales ($)",
        //                     data2: "Last Year Sales($)",
        //                     data3: "Member Id"
        //                 }
        //             }
        //         }
        //     });
        // }


    }
    componentDidMount() {
        let paramsValues = this.state.params;
        paramsValues = paramsToJSON(paramsValues);
        console.log('filters check', this.props.showMonth == "false");
        console.log('second check',this.state.showQuarter);
        if (this.props.showMonth == "false" && this.state.showQuarter === false) {
            this.setState({ showQuarter: false, buttonOptions: ["YTD", "QTR"], selectedFilter: "YTD" });
        }
        Axios.get(ROOT_URL + '/compliant?vendorId=' + (paramsValues.vendorId))
            .then(resp => this.setState
                ({
                    compliantvalue: resp.data,
                    addModalShow1: !resp.data,
                    addModalShow: !resp.data && !sessionStorage.getItem('flag')
                }));
        let params = jsonToParam(paramsValues);
        Promise.all([
            this.props.getVendorMonthsFilterAPI(this.state.params),
            this.props.tabTrackingAPI("tabId=9"),
            
        ]).then(data => {
            this.getOptions();
            this.getOptionsYear();
            this.setState({
                isLoading: false,


            })
        }).catch(err => {

            this.setState({
                isLoading: false
            })
            window.location.reload();

        })
        let checkStorage = localStorage.getItem('flag')
        if (checkStorage == "1") {
            this.setState({ addModalShow: true });
            console.log('if condition')
        }
        setTimeout(function () { localStorage.removeItem("flag"); }, 4000);
        // let checkStorage1 = localStorage.setItem('flag1','11')
        // setTimeout(function () { localStorage.removeItem("flag1"); }, 5000);


    }

    /* Member dropdown code added for Member purchase comparison graph*/
    handleClickMemberFull = (e, value) => {
        
        let params = this.state.params;
        params = paramsToJSON(params);
        let arr = [];
        let valstr = [value.value];
        if (valstr != "" && valstr != "undefined") {
            let valueee = valstr.map((option, index) => {
                let val = _find(value.options, ['value', option])
                arr.push(val.value)
            })
            params.memberId = arr
        }
        else {
            params.memberId = "";
        }
        //let displaydate = this.props.memberdate[arr]
        params = jsonToParam(params);
        this.props.getMemberPurchasesDataaAPI(params)
        this.props.getMemberVendorDateAPI(params)
        
        
        

            
        this.setState({
           params: params,
         //  memberdate:memberdate,
          })
        

    }
    /* member purchase dropdown code ended*/

    handleChangeOfDropdown(event) {
        let params = this.state.params;
        params = paramsToJSON1(params);
        let obj = {};
        obj[event.name] = event.value;
        params.quarter = event.value;
        let quarter = params.quarter
        params = jsonToParam(params);
        this.setState({
            quarter: quarter,
            params: params
        })
        this.setState(obj, () => {
            this.setFilter({ period: this.state.selectedFilter, quarter: this.state.quarter });
        });

    }

    handleChangeOfDropdownMonth = (e) => {
        let params = this.state.params;
        params = paramsToJSON1(params);
        let month = ''
        params.month = e.value
        month = params.month
        let selectedItem = { label: monthName1(month), value: month }
        if (month >= 1 && month <= 3) {
            params.quarter = 1
        }
        else if (month >= 4 && month <= 6) {
            params.quarter = 2
        }
        else if (month >= 7 && month <= 9) {
            params.quarter = 3
        }
        else if (month >= 10 && month <= 12) {
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            params: params,
            selectedItem: selectedItem,

        })

        this.props.getVendorSalesRebatCardDataAPI(params)
        this.props.getDashboardRebatesOverviewAPI(params)
        this.props.getDashboardSalesOpportunityGraphAPI(params)
        this.props.getDashboardGrowthRebateAPI(params)
        this.props.getDashboardSalesOpportunityByRegionAPI(params)
        this.props.getDashboardSalesOpportunityByMemberAPI(params)
        this.props.getDashboardSalesOpportunityByBusinessAPI(params)
        this.props.getVendorOpportunityByCategoryDataAPI(params)
        this.props.getStateRegionsAPI(params)
        this.props.getStateToStateMappingAPI(params)
        this.props.getProductCategorycorporateAPI(params)
        this.props.getDashboardIndividualGrowthRebateAPI(params)
        this.props.getMemberPurchasesDataaAPI(params)
        this.props.getMemberListAPI(params)





    }
    handleChangeOfDropdownYear(e) {
        
        let params = this.state.params;
        params = paramsToJSON1(params);
        let year = ''
        let items = []
        params.year = e.value
        year = params.year
        let selectedYear = { label: year, value: year }
        let dataval = Object.keys(this.props.getVendorMonthsFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })

        let selectedYear1 = yearval[yearval.length - 1];
        // if (selectedYear1.value != 2023 && e.value == 2023) {
            if (selectedYear1.value != 2024 && e.value == 2024 ){
            items = [{ label: monthName1(1), value: 1 }];
        }
        else {
            let dataval1 = Object.values(this.props.getVendorMonthsFilter[year]);
            if (typeof dataval1 == 'undefined') {
                items = [{ label: monthName1(1), value: 1 }];

            }
            else {
                items = dataval1.map(itemval => {
                    return {
                        label: monthName1(itemval),
                        value: itemval,
                    }

                })
            }
        }

        let selectedItem = items[items.length - 1];
        params.month = selectedItem.value;
        let month = selectedItem.value;
        if (month >= 1 && month <= 3) {
            params.quarter = 1
        }
        else if (month >= 4 && month <= 6) {
            params.quarter = 2
        }
        else if (month >= 7 && month <= 9) {
            params.quarter = 3
        }
        else if (month >= 10 && month <= 12) {
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            params: params,
            selectedYear: selectedYear,
            items: items,
            selectedItem: selectedItem,
        })
        this.setState(e, () => {
            this.setFilter({ year: this.state.year, selectedYear: selectedYear, selectedItem: selectedItem });
        });
        
        //console.log(this.state.selectedYear);


    }
    getOptionsYear() {

        let dataval = Object.keys(this.props.getVendorMonthsFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })
        let selectedYear = yearval[yearval.length - 1];
        // if (selectedYear.value != 2021 && selectedYear.value != 2022 && selectedYear.value != 2023)
        if (selectedYear.value != 2021 && selectedYear.value != 2022 && selectedYear.value != 2023 && selectedYear.value != 2024)
        {
        yearval.push({ label: 2021, value: 2021 });
        yearval.push({ label: 2022, value: 2022 });
        yearval.push({ label: 2023, value: 2023 });
        yearval.push({ label: 2024, value: 2024 });
        }
        // else if (selectedYear.value != 2023 && selectedYear.value == 2022){
            else if (selectedYear.value != 2023 && selectedYear.value != 2024){
            yearval.push({ label: 2023, value: 2023 });
            yearval.push({ label: 2024, value: 2024 });

        }
         //add this new code
         else if (selectedYear.value != 2024){
            yearval.push({ label: 2024, value: 2024 });
  
        }
        // params = jsonToParam(params);
        this.setState({
            selectedYear: selectedYear,
            yearval: yearval,
            // params: params ,
        })
    }
    getOptions() {

        let params = this.state.params;
        params = paramsToJSON1(params);
        let items = []
        let dataval = Object.keys(this.props.getVendorMonthsFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })
        let selectedYear1 = yearval[yearval.length - 1];

        let dataval1 = Object.values(this.props.getVendorMonthsFilter[selectedYear1.value]);
        if (typeof dataval1 == 'undefined') {
            items = [{ label: monthName1(1), value: 1 }];

        }
        else {
            items = dataval1.map(itemval => {
                return {
                    label: monthName1(itemval),
                    value: itemval,
                }

            })
        }

        if (selectedYear1.value != 2022) {
            yearval.push({ label: 2022, value: 2022 });
        }


        let selectedItem = items[items.length - 1];
        params.month = selectedItem.value;
        params.year = selectedYear1.value;
        let month = selectedItem.value;
        if (month >= 1 && month <= 3) {
            params.quarter = 1
        }
        else if (month >= 4 && month <= 6) {
            params.quarter = 2
        }
        else if (month >= 7 && month <= 9) {
            params.quarter = 3
        }
        else if (month >= 10 && month <= 12) {
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            items: items,
            selectedItem: selectedItem,
            params: params,
        })
        this.props.getVendorSalesRebatCardDataAPI(params)
        this.props.getDashboardRebatesOverviewAPI(params)
        this.props.getDashboardSalesOpportunityGraphAPI(params)
        this.props.getDashboardGrowthRebateAPI(params)
        this.props.getDashboardSalesOpportunityByRegionAPI(params)
        this.props.getDashboardSalesOpportunityByMemberAPI(params)
        this.props.getDashboardSalesOpportunityByBusinessAPI(params)
        this.props.getVendorOpportunityByCategoryDataAPI(params)
        this.props.getStateRegionsAPI(params)
        this.props.getStateToStateMappingAPI(params)
        this.props.getProductCategorycorporateAPI(params)
        this.props.getDashboardIndividualGrowthRebateAPI(params)
        this.props.getMemberPurchasesDataaAPI(params)
        this.props.getMemberListAPI(params)
        this.props.getMemberVendorDateAPI(params)


    }

    renderButtonGroup() {
        return this.state.buttonOptions.map((option, index) => {
            return (
                <button style={{ height: '38px' }} key={index} type="button" value={option}
                    onClick={(e) => { console.log(e.target.value); this.handleUserSelectedFilter(e.target.value) }}
                    class={`btn btn-light ${(this.state.selectedFilter === option) ? "active" : null}`}>{option}</button>
            )
        })
    }
    renderPaginationShowsTotal(start, to, total) {
        return (
            <p style={{ color: '' }}>
                Showing rows { start} to { to}
            </p>
        );
    }


    // renderRebatesOverview(cardSection) {
    //     return (
    //         <div className="col-12">
    //             <div className="panel-wrapper">
    //                 <div className="panel-header">
    //                     <h3>Rebates Overview</h3>
    //                 </div>
    //                 <div className="panel-body">
    //                     <div className="row">
    //                         {cardSection}
    //                     </div>

    //                 </div>
    //             </div>
    //         </div>
    //     )
    // }
    // renderOverallSalesAndRebate(cardSection) {
    //     return (
    //         <div className="col-12">
    //             <div className="panel-wrapper">
    //                 <div className="panel-header">
    //                     <h3>Overall Volume and Rebate ( Member Data )</h3>
    //                 </div>
    //                 <div className="panel-body">
    //                     <div className="row">
    //                         {cardSection}
    //                     </div>

    //                 </div>
    //             </div>
    //         </div>
    //     )
    // }

    setFilter = (filter) => {
        
        console.log(filter);
        let params = this.state.params;
        params = paramsToJSON(params);
        params.memberId='';
        if (filter.period === "qtr" || filter.period == "QTR") {
            params.qtr = "true";
            params.mth = "false";
            params.ytd = "false";

            params.period = filter.period;
        } else if (filter.period === "MTH" || filter.period == "mth") {

            params.qtr = "false";
            params.mth = "true";
            params.ytd = "false";
            params.period = filter.period;
        } else if (filter.period === "YTD" || filter.period == "ytd") {
            params.qtr = "false";
            params.mth = "false";
            params.ytd = "true";

            params.period = filter.period;
        }
        else if (filter.year != undefined) {
            params.year = filter.year;

        }
        else if (filter.month != undefined) {
            params.month = filter.month;

        }
        else if (filter.quarter != undefined) {
            console.log("Hello");
            params.quarter = filter.quarter;

        }
        params = jsonToParam(params);
        this.setState({

            params: params,
            refreshData: true,
            isLoading: true,

        }, () => Promise.all([
            this.props.getVendorSalesRebatCardDataAPI(this.state.params),
            this.props.getDashboardRebatesOverviewAPI(this.state.params),
            this.props.getDashboardSalesOpportunityGraphAPI(this.state.params),
            this.props.getDashboardGrowthRebateAPI(this.state.params),
            this.props.getDashboardSalesOpportunityByRegionAPI(this.state.params),
            this.props.getDashboardSalesOpportunityByMemberAPI(this.state.params),
            this.props.getDashboardSalesOpportunityByBusinessAPI(this.state.params),
            this.props.getVendorOpportunityByCategoryDataAPI(this.state.params),
            this.props.getStateRegionsAPI(this.state.params),
            this.props.getStateToStateMappingAPI(this.state.params),
            this.props.getProductCategorycorporateAPI(this.state.params),
            this.props.getDashboardIndividualGrowthRebateAPI(this.state.params),
            this.props.getMemberPurchasesDataaAPI(this.state.params),
            this.props.getMemberListAPI(this.state.params),
            this.props.getMemberVendorDateAPI(this.state.params)


        ]).then(([vpVolumeData, groupRebate]) => {

            this.setState({
                isLoading: false,
                vendorPartnerVolumeListData: vpVolumeData,
                groupRebatesListData: groupRebate
            })
        }).catch(err => {

            this.setState({
                isLoading: false
            })
        }))
        this.refs.memberListvalue.value = '';


    }
    AttainmentComp = (cell, rows) => {

        let percentAttained = _get(rows, 'attainmentPercent', 0);
        if (percentAttained >= 100) {
            return (
                <div className={"attainmentGreen"}>{Number(percentAttained).toFixed(1)}</div>
            )
        } else if (percentAttained >= 75 && percentAttained < 100) {
            return (
                <div className={"attainmentYellow"}>{Number(percentAttained).toFixed(1)}</div>
            )
        }
        else if (percentAttained >= 0 && percentAttained < 75) {
            return (
                <div className={"attainmentRed"}>{Number(percentAttained).toFixed(1)}</div>
            )
        }
    }

    // TierComponent = (cell, rows) => {
    //     let tier = _get(rows, 'tierId', "")
    //     if (tier) {
    //         return <div className="tier">{tier}</div>
    //     }
    // }
    TierComponent = (cell, rows) => {
        let tier = _get(rows, 'tier', "")
        if (tier) {
            return <div className="tier">{tier}</div>
        }
    }
    TierCriteria = (cell, rows) => {
        let sales = '$0';
        return <React.Fragment>

            {rows.criteria.map(sales =>
                <Row style={{ overflowWrap: 'break-word', width: '100px', flexWrap: 'inherit !important' }} className="ml-2">
                    {<Row style={{ marginBottom: '4px' }}>{sales}</Row>}
                </Row>

            )}
        </React.Fragment>

    }
    /// 

    renderGrowthTiers = (growthTier) => {

       // console.log('Rendering Tiers', growthTier);
        let variant = 'success';
        let minimumAttainment = Math.min.apply(null, Array.from(growthTier.rebateTierCriteria.map(tierCriteria => tierCriteria.attainmentPercent)));
        if (minimumAttainment <= 50) {
            variant = 'danger';
        } else if (minimumAttainment < 100) {
            variant = 'warning';
        }
        return (
            <OverlayTrigger overlay={(<Tooltip>{
                <React.Fragment>
                    <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>{"GROWTH"}</div>
                    <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>Tier: {growthTier.tier}</div>
                    {/* <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>Rebate($): {PriceFormatter(growthTier.rebate)}</div>
                <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>Rebate(%): {PercentFormatter(growthTier.rebatePercent)}</div>
                  */}
                    {growthTier.rebateTierCriteria.map((criteria, index) => {
                        if (criteria.criteriaSetting == 'Absolute') {
                            return <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>
                                <div>Criteria {(index + 2) + ': ' + criteria.criteria}</div>

                                <div>Condition : {(criteria.criteria.includes('Pounds'))?(Math.trunc(criteria.requiredGrowth).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))+' '+'lbs' :PriceFormatter1(criteria.requiredGrowth)}  <i class="fa fa-arrow-up" aria-hidden="true"></i></div>
                                <div>Target : {PriceFormatter1(criteria.target)}</div>
                                <div>Actual : {PriceFormatter1(criteria.actual)}</div>
                                {/* <div>Growth : {PriceFormatter1(criteria.requiredGrowth)}</div> */}
                                <div>Gap : {PriceFormatter1(criteria.gap)}</div>
                                <div>Attainment : {PercentFormatter(criteria.attainmentPercent)}</div>
                            </div>
                        }
                        else if (criteria.criteriaSetting == 'Percentage') {
                            return <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>
                                <div>Criteria {(index + 2) + ': ' + criteria.criteria}</div>

                                <div>Condition : {PercentFormatter1(criteria.requiredGrowth)}  <i class="fa fa-arrow-up" aria-hidden="true"></i></div>
                                <div>Target : {(criteria.criteria.includes('Pounds'))?(Math.trunc(criteria.target).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))+' '+'lbs' :PriceFormatter1(criteria.target)}</div>
                                <div>Actual : {(criteria.criteria.includes('Pounds'))?(Math.trunc(criteria.actual).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))+' '+'lbs' :PriceFormatter1(criteria.actual)}</div>
                                {/* <div>Growth : {PriceFormatter1(criteria.requiredGrowth)}</div> */}
                                <div>Gap : {(criteria.criteria.includes('Pounds'))?(Math.trunc(criteria.gap).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))+' '+'lbs' :PriceFormatter1(criteria.gap)}</div>
                                <div>Attainment : {PercentFormatter(criteria.attainmentPercent)}</div>
                            </div>
                        }
                    })}
                </React.Fragment>
            }</Tooltip>)}
                popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">
                <Col style={{ 'padding': '1px' }}><div className={'bg-' + variant} style={{ 'width': '100%', 'height': '15px' }}></div></Col>
            </OverlayTrigger>
            // END COL
        )

    };

    GrowthTier = (cell, rows) => {

       // console.log('Growth Rebate', rows.rebateTierVendor);
        if (rows.rebateTierVendor && rows.rebateTierVendor.length > 0) {
            return <React.Fragment>{rows.rebateTierVendor.map(rebateProgram =>
                <Row style={{ width: '100px', flexWrap: 'inherit !important' }} className="ml-2">
                    {/* {rebateProgram.rebateTierCriteria.map(programTiers =>  */}
                    {this.renderGrowthTiers(rebateProgram)
                    }
                </Row>)
            }</React.Fragment>;
        } else {
            return <div></div>;
        };
    };

    //
    // GrowthTierVerified

    renderGrowthTiersVerified = (growthTier) => {

       // console.log('Rendering Tiers', growthTier);
        let variant = 'success';
        let minimumAttainment = Math.min.apply(null, Array.from(growthTier.rebateTierCriteria.map(tierCriteria => tierCriteria.attainmentPercent)));
        if (minimumAttainment <= 50) {
            variant = 'danger';
        } else if (minimumAttainment < 100) {
            variant = 'warning';
        }
        return (
            <OverlayTrigger overlay={(<Tooltip>{
                <React.Fragment>
                    <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>{"GROWTH"}</div>
                    <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>Tier: {growthTier.tier}</div>
                    {/* <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>Rebate($): {PriceFormatter(growthTier.rebate)}</div>
                <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>Rebate(%): {PercentFormatter(growthTier.rebatePercent)}</div>
                   */}
                    {growthTier.rebateTierCriteria.map((criteria, index) => {
                        if (criteria.criteriaSetting == 'Absolute') {
                            return <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>
                                <div>Criteria {(index + 1) + ': ' + criteria.criteria}</div>
                                <div>Condition : {(criteria.criteria.includes('Pounds'))?(Math.trunc(criteria.requiredGrowth).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))+' '+'lbs' :PriceFormatter1(criteria.requiredGrowth)}  <i class="fa fa-arrow-up" aria-hidden="true"></i></div>
                                <div>Target : {PriceFormatter1(criteria.target)}</div>
                                <div>Actual : {PriceFormatter1(criteria.actual)}</div>
                                {/* <div>Growth : {PriceFormatter1(criteria.requiredGrowth)}</div> */}
                                <div>Gap : {PriceFormatter1(criteria.gap)}</div>
                                <div>Attainment : {PercentFormatter(criteria.attainmentPercent)}</div>
                            </div>
                        }
                        else if (criteria.criteriaSetting == 'Percentage') {
                            return <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>
                                <div>Criteria {(index + 1) + ': ' + criteria.criteria}</div>
                                {console.log('891',(Math.trunc(criteria.target).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')))}
                                <div>Condition : {PercentFormatter1(criteria.requiredGrowth)}  <i class="fa fa-arrow-up" aria-hidden="true"></i></div>
                                <div>Target : {(criteria.criteria.includes('Pounds'))?(Math.trunc(criteria.target).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))+' '+'lbs' :PriceFormatter1(criteria.target)}</div>
                                <div>Actual : {(criteria.criteria.includes('Pounds'))? (Math.trunc(criteria.actual).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))+' '+'lbs':PriceFormatter1(criteria.actual)}</div>
                                {/* <div>Growth : {PriceFormatter1(criteria.requiredGrowth)}</div> */}
                                <div>Gap : {(criteria.criteria.includes('Pounds'))? (Math.trunc(criteria.gap).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))+' '+'lbs':PriceFormatter1(criteria.gap)}</div>
                                <div>Attainment : {PercentFormatter(criteria.attainmentPercent)}</div>
                            </div>
                        }
                    })}
                </React.Fragment>
            }</Tooltip>)}
                popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">
                <Col style={{ 'padding': '1px' }}><div className={'bg-' + variant} style={{ 'width': '100%', 'height': '15px' }}></div></Col>
            </OverlayTrigger>
            // END COL
        )

    };

    // member sales support score
    RenderMemberSalesScore = (cell, rows) => {

        return (
            <OverlayTrigger overlay={(<Tooltip>{
                <React.Fragment>
                    <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>{'hii'}</div>
                    <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>Tier: {'hello'}</div>
                </React.Fragment>
            }</Tooltip>)}
                popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">
            </OverlayTrigger>
            // END COL
        )
    };

    //ended .


    GrowthTierVerified = (cell, rows) => {

       // console.log('Growth Rebate', rows.rebateTierVerified);
        if (rows.rebateTierVerified && rows.rebateTierVerified.length > 0) {
            return <React.Fragment>{rows.rebateTierVerified.map(rebateProgram =>
                <Row style={{ width: '100px', flexWrap: 'inherit !important' }} className="ml-2">
                    {/* {rebateProgram.rebateTierCriteria.map(programTiers =>  */}
                    {this.renderGrowthTiersVerified(rebateProgram)
                    }
                </Row>)
            }</React.Fragment>;
        } else {
            return <div></div>;
        };
    };

    RebateVerified = (cell, rows) => {
        // if (rows.rebatePercentList && rows.rebatePercentList > 0) {
        return <React.Fragment>
            {rows.rebatePercentList.map((rebatePercent, index) =>
                <Row style={{ width: '100px', flexWrap: 'inherit !important' }} className="ml-2">
                    {/* {<Row style={{ marginBottom: '4px' }}>{rebatePercent}</Row>} */}
                 Tier{(index + 1)} <div className={"tier"} style={{ marginBottom: '4px' }}>{Number(rebatePercent).toFixed(1)}</div>
                </Row>)
            }</React.Fragment>;
        // } else {
        //     return <div></div>;
        // };

    };

    //

    // TierCriteriaIndividualLevel = (cell, rows) => {
    //     
    //     let sales= '$0';
    //      return <React.Fragment>
    //  { rows.rebateTierVendor.map(sales11 => 
    //   //sales11.tier.map(sales1 => 
    //         //{ sales1.criteria.map(sales2 => 

    //         <Row style={{ overflowWrap:'break-word',width: '100px', flexWrap:'inherit !important'}} className="ml-2">
    //           { <Row style={{ marginBottom:'4px'}}>{sales11}</Row> }
    //           </Row>

    //       //  )}
    //   //)
    //  )}

    //         </React.Fragment>
    // 
    // }

    currentYearSales = (cell, rows) => {
        let sales = '$0';
        return <React.Fragment>

            {rows.currentYearSales.map(sales =>
                <Row style={{ overflowWrap: 'break-word', width: '100px', flexWrap: 'inherit !important' }} className="ml-2">
                    {sales = PriceFormatter1(sales),
                        <Row style={{ marginBottom: '4px' }}>{sales}</Row>
                    }
                </Row>
            )}

        </React.Fragment>

    }
    TargetSales = (cell, rows) => {
        let sales = '$0';
        return <React.Fragment>
            {rows.targetSales.map(sales =>
                <Row style={{ overflowWrap: 'break-word', width: '100px', flexWrap: 'inherit !important' }} className="ml-2">
                    {sales = PriceFormatter1(sales),
                        <Row style={{ marginBottom: '4px' }}>{sales}</Row>
                    }
                </Row>
            )}

        </React.Fragment>
    }
    gapAmount = (cell, rows) => {
        let sales = '$0';
        return <React.Fragment>
            {rows.gapAmount.map(sales => {
                if (sales >= 0) {
                    return (
                        <Row style={{ marginBottom: '4px', width: '100px', flexWrap: 'inherit !important' }} className="ml-2">

                            <div className={"greenText"}>{PriceFormatter1(sales)}</div>

                        </Row>
                    )
                }
                else if (sales >= 0) {
                    return (
                        <Row style={{ marginBottom: '4px', width: '100px', flexWrap: 'inherit !important' }} className="ml-2">

                            <div className={"redText"}>{PriceFormatter1(sales)}</div>

                        </Row>
                    )
                }
            })
            }
        </React.Fragment>
    }

    AttainmentComp = (cell, rows) => {

        let percentAttained = '0.00';
        return <React.Fragment>
            {rows.attainmentPercent.map(percentAttained => {
                if (percentAttained >= 100) {
                    return (
                        // <OverlayTrigger overlay={(<Tooltip> 
                        // {rows.criteria.map((criteria , index) => "Attainment percent for" + criteria)} </Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                        <Row style={{ marginBottom: '4px' }}>

                            <div className={"attainmentGreen"}>{Number(percentAttained).toFixed(1)}</div>

                        </Row>
                        // </OverlayTrigger>
                    )
                }
                if (percentAttained >= 75 && percentAttained < 100) {
                    return (
                        // <OverlayTrigger overlay={(<Tooltip> 
                        // {rows.criteria.map(criteria => "Attainment percent for" + criteria)} </Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                        <Row style={{ marginBottom: '4px' }}>
                            <div className={"attainmentYellow"}>{Number(percentAttained).toFixed(1)}</div>

                        </Row>
                        // </OverlayTrigger>
                    )
                }
                if (percentAttained >= 0 && percentAttained < 75) {
                    return (
                        // <OverlayTrigger overlay={(<Tooltip> 
                        // {rows.criteria.map(criteria => "Attainment percent for" + criteria)} </Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                        <Row style={{ marginBottom: '4px' }}>
                            <div className={"attainmentRed"}>{Number(percentAttained).toFixed(1)}</div>

                        </Row>
                        // </OverlayTrigger>
                    )
                }
            })
            }
        </React.Fragment>
    }
    // Poungds, sales, unit calculation 
    // criteria,currentYearSales,targetSales,gapAmount

    PoundSalesCalculation = (cell, rows) => {

        let salesCurrentYear = _get(rows, 'currentYearSales', 0);

        return <React.Fragment>
            {rows.criteria.map((criteriaName, index) => {
              //  console.log("ssssssssssss", criteriaName.toLowerCase())
                if (criteriaName.toLowerCase().includes('sales')) {


                    return (

                        <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                            <div>{formatCurrency(salesCurrentYear[index])}</div>


                        </Row>
                    )



                }
                else if (criteriaName.toLowerCase().includes('pounds')) {

                    return (

                        <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                            <div>{formatPounds(salesCurrentYear[index])}</div>


                        </Row>
                    )

                }
                else if (criteriaName.toLowerCase().includes('units')) {

                    return (

                        <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                            <div>{formatUnits(salesCurrentYear[index])}</div>


                        </Row>
                    )

                }
            })}
        </React.Fragment>
    }

    PoundCurrencyGapCalculation = (cell, rows) => {

        //   let criteriaName = _get(rows, 'criteria', 0);
        let gap = _get(rows, 'gapAmount', 0);
        return <React.Fragment>
            {rows.criteria.map((criteriaName, index) => {

                if (criteriaName.toLowerCase().includes('sales')) {


                    return (

                        <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                            <div className='greenText'>{formatCurrency(gap[index])}</div>


                        </Row>
                    )


                }
                else if (criteriaName.toLowerCase().includes('pounds')) {

                    return (

                        <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                            <div className='greenText'>{formatPounds(gap[index])}</div>


                        </Row>
                    )
                }
                else if (criteriaName.toLowerCase().includes('units')) {

                    return (

                        <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                            <div className='greenText'>{formatUnits(gap[index])}</div>


                        </Row>
                    )
                }
            })}
        </React.Fragment>


    }
    PoundCurrencyLYCalculation = (cell, rows) => {

        let criteriaName = _get(rows, 'criteria', 0);
        let salesCurrentYear = _get(rows, 'salesCurrentYear', 0);
        let salesLastYear = _get(rows, 'salesLastYear', 0);
        let target = _get(rows, 'target', 0);
        let gap = _get(rows, 'gap', 0);


        if (criteriaName.toLowerCase().includes('sales')) {
            return (
                <div >{formatCurrency(salesLastYear)}</div>
            )
        } else if (criteriaName == "Pounds CY" || criteriaName == "Pounds LY" || criteriaName == "Group_Pounds LY" || criteriaName == "Group_Pounds CY") {
            return (
                <div >{formatPounds(salesLastYear)}</div>
            )
        }
        else if (criteriaName.toLowerCase().includes('units')) {
            return (
                <div >{formatUnits(salesLastYear)}</div>
            )
        }


    }
    PoundCurrencyTargetCalculation = (cell, rows) => {

        let criteriaName = _get(rows, 'criteria', 0);
        let target = _get(rows, 'targetSales', 0);

        return <React.Fragment>
            {rows.criteria.map((criteriaName, index) => {

                if (criteriaName.toLowerCase().includes('sales')) {


                    return (

                        <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                            <div className='greenText'>{formatCurrency(target[index])}</div>

                        </Row>
                    )


                }
                else if (criteriaName.toLowerCase().includes('pounds')) {

                    return (

                        <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                            <div className='greenText'>{formatPounds(target[index])}</div>

                        </Row>
                    )
                }
                else if (criteriaName.toLowerCase().includes('units')) {

                    return (

                        <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                            <div className='greenText'>{formatUnits(target[index])}</div>

                        </Row>
                    )
                }
            })}
        </React.Fragment>


    }

    PoundCurrencyRebateCalculation = (cell, rows) => {

        //   let criteriaName = _get(rows, 'criteria', 0);
        let rebateAmount = _get(rows, 'rebateAmount', 0);
        return <React.Fragment>
            {rows.criteria.map((criteriaName, index) => {

                if (criteriaName.toLowerCase().includes('sales')) {


                    return (

                        <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                            <div className='greenText'>{formatCurrency(rebateAmount)}</div>


                        </Row>
                    )


                }
                else if (criteriaName.toLowerCase().includes('pounds')) {

                    return (

                        <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                            <div className='greenText'>{formatPounds(rebateAmount)}</div>


                        </Row>
                    )
                }
                else if (criteriaName.toLowerCase().includes('units')) {

                    return (

                        <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                            <div className='greenText'>{formatUnits(rebateAmount)}</div>


                        </Row>
                    )
                }
            })}
        </React.Fragment>


    }

    // Poungds, sales, unit calculation  ended
    renderVectorMap() {
        const { salesOpportunityByRegion } = this.props;
        const { stateRegionMapping } = this.props;

        let regionDetails = {};
        if (salesOpportunityByRegion) {
            salesOpportunityByRegion.map((missedAmount) => {
                let state = missedAmount.region.toLowerCase();
                let region = stateRegionMapping[state];
                //make region name as key, and as value keep an object that has info like sum and count
                let obj = {};
                if (regionDetails.hasOwnProperty(region)) {

                    let valueOfState = missedAmount.missedAmount;
                    let previousSumValue = regionDetails[region].sum;
                    let previousCountValue = regionDetails[region].count;
                    obj = {
                        sum: valueOfState + previousSumValue,
                        count: previousCountValue + 1
                    }
                    regionDetails[region] = obj;
                } else {

                    let valueOfState = missedAmount.missedAmount;
                    obj = {
                        sum: valueOfState,
                        count: 1
                    }
                    regionDetails[region] = obj;
                }
            });
        }

        //now iterate over all objects, and add a field called average
        Object.keys(regionDetails).forEach(function (key) {
            let average = regionDetails[key].sum / regionDetails[key].count;
            average = average.toFixed(2);
            regionDetails[key].average = average;
        })
        //now iterate over the data from API , grab the region, and then assign the average value
        //calculated above to opportunity value
        let objForMap = {};
        //new approach
        // iterate over stateregionmapping, get state, find region, get value, assign it to obj

        Object.keys(stateRegionMapping).forEach(function (key) {
            let state = key;
            //find region
            let region = stateRegionMapping[key];
            //check if data exists
            if (regionDetails.hasOwnProperty(region)) {
                let regionVal = regionDetails[region].average;
                objForMap["US-" + key.toUpperCase()] = regionVal;
            } else {

                objForMap["US-" + key.toUpperCase()] = 0;
            }
        });

        const series = {
            regions: [{
                values: objForMap,
                scale: ['#FEE5D9', '#A50F15'],
                normalizeFunction: 'polynomial',

            }]
        }
        return (
            <VectorMap map={'us_aea'}
                // ref={this.vectorMapRef}
                backgroundColor="transparent"
                series={series}
                ref="map"
                regionsSelectable="true"
                selectedRegions={this.state.selectedStates}
                regionStyle={{
                    initial: {
                        fill: "#e4e4e4",
                        "fill-opacity": 0.9,
                        stroke: "none",
                        "stroke-width": 0,
                        "stroke-opacity": 0
                    },
                    hover: {
                        "fill-opacity": 0.8,
                        cursor: "pointer"
                    },
                    selected: {
                        fill: "rgb(43, 142, 187)"
                    },
                    selectedHover: {}
                }}

                onRegionTipShow={(e, el, code) => this.handleMouseEvent(e, el, objForMap[code])}
                onRegionClick={(e, el, code) => this.handleRegionClick(e, el, code)}
                containerStyle={{
                    width: '450px',
                    height: '450px',
                }}

            />

        )

    }
    hideRegionTip() {
        let arr = document.getElementsByClassName('jvectormap-tip');

        for (let i = 0; i < arr.length; i++) {
            arr[i].style.display = "";
        }

    }
    handleRegionClick(e, el, code) {
        let params = this.state.params;
        params = paramsToJSON(params);
        const { stateRegionMapping } = this.props;
        let stateSelectedTrimmed = el.substring(3).toLowerCase();
        let regionSelected = stateRegionMapping[stateSelectedTrimmed];
        //  regionSelected = stateSelectedTrimmed;
        let statesToBeSelected = [];
        Object.keys(stateRegionMapping).forEach(function (key, index) {
            if (stateRegionMapping[key] === regionSelected) {
                console.log('it matches ', key);
                let modifiedName = "US-" + key;
                modifiedName = modifiedName.toUpperCase();
                console.log('modified name ', modifiedName);
                statesToBeSelected.push(modifiedName);
            }
        })
        params.region = regionSelected;
        params.dropDown = [];
        this.setState({ params: jsonToParam(params), selectedStates: statesToBeSelected }, () => {
            this.props.getDashboardSalesOpportunityByMemberAPI(this.state.params);
            this.props.getDashboardSalesOpportunityByBusinessAPI(this.state.params);
            this.props.getVendorOpportunityByCategoryDataAPI(this.state.params);
        });
    }

    handleMouseEvent(e, el, salesObj) {
        const { salesOpportunityByRegion } = this.props;
        const stateToStateMapping = this.props.stateToStateMapping;
        const stateRegionMapping = this.props.stateRegionMapping;
        let stateForRegionMapping = stateToStateMapping[el.html()];
        let region = this.props.stateRegionMapping[stateForRegionMapping];
        // let arr = document.getElementsByClassName('jvectormap-tip');

        // for (let i = 0; i < arr.length; i++) {
        //     arr[i].style.display = 'visible';
        // }
        if (salesObj) {
            el.html(el.html() + "<div>" + regionCodeNameMapping[region] + "</div><hr><div>Sales Opportunity</div>" + accounting.formatMoney(salesObj))

        } else {
            el.html(el.html() + "<div>" + region + "</div><hr><div>" + el.html() + "</div>");
        }

    }
    handleRowClickMember = row => {

        let params = this.state.params;
        params = paramsToJSON(params);
        params.memberId = row.memberId;
        // params.productGroupId = encodeURIComponent(row.tierFourId);
        params = jsonToParam(params);

        this.props.getDashboardSalesOpportunityByRegionAPI(params);
        this.props.getDashboardSalesOpportunityByBusinessAPI(params);
        this.props.getVendorOpportunityByCategoryDataAPI(params);

    }
    //Starting prouct detail 
    showProductListModal = (row) => {
        this.setState({
            vendorId: row.vendorId, productGroupId: row.tierFourId, productGroupName: row.tierFour,
            showProductListModal: true, showProductListModalPopUp: true
        }, () => {
            let selections = this.state.params;
            selections = paramsToJSON(selections);
            selections.productGroupId = this.state.productGroupId;

            selections = jsonToParam(selections);
            console.log(selections);
            this.props.getProductListVendorDashboardAPI(selections, (res) => {
                swal(res.data.message);
            });
        });
    }
    closeProductListModal = () => {
        this.setState({ showProductListModal: false, showProductListModalPopUp: false });
    }
    //     showProductFeedbackIcon = (cell, row) => {
    //         //;
    //         return (
    //             <OverlayTrigger overlay={(<Tooltip id="hi">Feedback for {row.productDescription}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

    //             <Link onClick={(e) => {
    //                  e.preventDefault();
    //                 this.showProductFeedbackModal(row)
    //             }}> < i className="fas fa-comment-alt"></i></Link>
    //             </OverlayTrigger>
    //         )
    //     }
    //     showProductFeedbackModal = (row) => {
    //   //;
    //         this.setState({ productId: row.productId, productName:row.productName, selectedCategoryId: row.productGroupId, productDesc: row.productName, 
    //             selectedCategory: row.productGroupName, outVendorName: row.outVendorName,
    //             selectedFavorableVp:row.favorableVendorName,selectedFavorableVpId:row.favorableVendorId, showProductFeedbackModal: true });

    //     }
    //     closeProductFeedbackModal = () => {
    //         this.setState({ showProductFeedbackModal: false });
    //     }
    //     sendProductFeedback() {
    //       //  ;
    //         let selections = {
    //             // statusForWrongClassification: this.state.feedbackToggleForWrongClassification,
    //             // statusForProductsNotSold: this.state.feedbackToggleForProductsNotSold,
    //             // statusForWrongVendor: this.state.feedbackToggleForWrongVendor,
    //             productDesc: (this.state.productDesc),
    //             productId: this.state.productId,
    //             categoryId: this.state.selectedCategoryId,
    //             categoryName: (this.state.selectedCategory),
    //             productCategoryWrong: this.state.feedbackToggleForWrongClassification,
    //             feedbackComment: (this.state.comments),
    //             productNotSold: this.state.feedbackToggleForProductsNotSold,
    //             suggestedCategoryId: this.state.suggestedCategoryId,
    //             suggestedCategoryName : (this.state.suggestedCategoryName),
    //             favorableVendorWrong: this.state.feedbackToggleForFavorableVp,
    //             //feedbackToggleForFavorableVp
    //             favorableVendorId: this.state.selectedVendorId,
    //             favorableVendorName: this.state.selectedVendorName,
    //             suggestedFavorableVendorId: this.state.suggestedFavorableVendorId ,
    //             suggestedFavorableVendorName: this.state.suggestedFavorableVendorName,

    //         }

    // // ;
    //         if (!this.state.suggestedCategoryName) {
    //             this.setState({ selectCategoryErrorMessage: 'Please select a category' }, () => {
    //             });
    //         } else if (!this.state.suggestedFavorableVendorName) {
    //             this.setState({ selectFavorableVpErrorMessage: 'Please select a favorable Supplier' }, () => {
    //             });
    //         } 
    //         else {
    //             this.setState({ showProductFeedbackModal: false, selectCategoryErrorMessage: '' }, () => {
    //                 // this.props.saveProductFeedbackAPI(selections, (res) => {
    //                 //      swal(res.data.text);
    //                      swal("Feedback Submitted successfully ...");
    //                 //  });
    //             });
    //             swal("Feedback Submitted successfully ...");
    //         }
    //         //call action now
    //     }
    //     showFeedbackModal = (row) => {
    //         //;
    //         this.setState({ vendorDisplayName: row.vendorName, showFeedbackModal: true });
    //     }
    //     closeFeedbackModal = () => {
    //         this.setState({ showFeedbackModal: false });
    //     }

    // Product detail ended
    getMemberDefaultData = (onClick) => {
        onClick();
        this.refs.table.cleanSelected();
        this.refs.table1.cleanSelected();
        this.refs.table2.cleanSelected();
        let params = this.state.params;
        params = paramsToJSON(params);
        params.businessId = "";
        params.region = "";
        params.tier2 = "";
        params.memberId = "";
        params = jsonToParam(params);
        this.setState({ params: params, })
        this.props.getDashboardSalesOpportunityByRegionAPI(params);
        this.props.getDashboardSalesOpportunityByBusinessAPI(params);
        this.props.getDashboardSalesOpportunityByMemberAPI(params);
        this.props.getVendorOpportunityByCategoryDataAPI(params);
        this.refs.table.reset();
        this.refs.table1.reset();
        this.refs.table2.reset();
    }
    ProgressBarProductGroup = (cell, row) => {
        this.vendorOpportunityByCategory.push(row.missedOpportunity)
        let max = Math.max(...this.props.MemberList);
        let str = accounting.formatMoney(cell);
        str = str.slice(0, -3);
        return (
            <React.Fragment>
                {/* <OverlayTrigger overlay={(<Tooltip>Missed Opportunity {PriceFormatter(row.missedOpportunity)}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">
         */}
                <div className="progress">

                    <div className="progress-bar" role="progressbar"
                        aria-valuemin="0" style={{ width: (cell / max) * 100 }}>
                    </div>
                </div>
                {/* </OverlayTrigger> */}
            </React.Fragment>

        )
    }
    ProgressBarBusiness = (cell, row) => {
        //;
        this.salesOpportunityByBusiness.push(row.opportunity)
        let max = Math.max(...this.props.VolumeList);
        let str = accounting.formatMoney(cell);
        str = str.slice(0, -3);
        return (
            <React.Fragment>
                {/* <OverlayTrigger overlay={(<Tooltip>Opportunity {PriceFormatter(row.opportunity)}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">
         */}
                <div className="progress">

                    <div className="progress-bar" role="progressbar"
                        aria-valuemin="0" style={{ width: (cell / max) * 100 }}>
                    </div>
                </div>
                {/* </OverlayTrigger> */}
            </React.Fragment>

        )
    }
    ProgressBarMember = (cell, row) => {
        //;
        this.getDashboardSalesOpportunityByMember.push(row.missedOpportunity)
        let max = Math.max(...this.props.PGList);
        let str = accounting.formatMoney(cell);
        str = str.slice(0, -3);
        return (
            <React.Fragment>
                {/* <OverlayTrigger overlay={(<Tooltip> Missed Opportunity {PriceFormatter(row.missedOpportunity)}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">
         */}
                <div className="progress">

                    <div className="progress-bar" role="progressbar"
                        aria-valuemin="0" style={{ width: (cell / max) * 100 }}>
                    </div>
                </div>
                {/* </OverlayTrigger> */}
            </React.Fragment>

        )
    }

    ProgressBarProductGroupDetails = (cell, row) => {
        this.getProductListVendorDashboard.push(row.missedSalesAmount)
        let max = Math.max(...this.props.CategoryList);
        let str = accounting.formatMoney(cell);
        str = str.slice(0, -3);
        return (
            <React.Fragment>
                {/* <OverlayTrigger overlay={(<Tooltip>Missed Opportunity {PriceFormatter(row.missedOpportunity)}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">
         */}
                <div className="progress">

                    <div className="progress-bar" role="progressbar"
                        aria-valuemin="0" style={{ width: (cell / max) * 100 }}>
                    </div>
                </div>
                {/* </OverlayTrigger> */}
            </React.Fragment>

        )
    }
    renderSizePerPageDropDown = props => {
        return (
            <div className='btn-group'>
                {
                    [25, 50, 100].map((n, idx) => {
                        const isActive = (n === props.currSizePerPage) ? 'active' : null;
                        return (
                            <button key={idx} type='button' className={`btn btn-info ${isActive}`} onClick={() => props.changeSizePerPage(n)}>{n}</button>
                        );
                    })
                }
            </div>
        );
    }

    renderDashboardSalesOpportunityByMember() {
        // this.getMemberDefaultData = [];
        this.getDashboardSalesOpportunityByMember = [];
        const options = {
            // paginationShowsTotal: this.renderPaginationShowsTotal,
            // sizePerPage: 100,
            sizePerPageDropDown: this.renderSizePerPageDropDown,
            clearSearch: true,
            clearSearchBtn: this.createCustomClearButtonForMember,
            //onRowClick: this.handleRowClickMember
            // onRowClick: this.showProductListModal
        }
        return (
            <div className="" >
                <div className="card-deck">
                    <div className="card shadow-sm mb-3">
                        <div className="card-body" style={{ maxHeight: " 410" }}>
                            <h5 style={{ textDecorationLine: 'underline', }}> Sales Opportunity by Member</h5>
                            {/* <button className="btn btn-primary" style={{ float: "right", marginTop: "2px" }} onClick={this.getMemberDefaultData} > Clear All </button>
                            */}
                            <BootstrapTable search options={options} ref="table" pagination height='400' data={this.props.getDashboardSalesOpportunityByMember} striped hover version="4">
                                {/* <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="80px" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} isKey dataField='memberId'>MemberId</TableHeaderColumn> */}
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="150px" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='memberName' isKey></TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="140px" dataSort={true} dataFormat={this.ProgressBarMember} dataField='missedOpportunity'></TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    selectRowProp = {
        mode: "radio",
        hideSelectColumn: true,
        clickToSelect: true,
        hideSelectAll: true,
        bgColor: "rgb(0,0,255)",
    };

    MemberScore = (cell, rows) => {

        if (rows.supportScore) {
            return (
                <OverlayTrigger overlay={(<Tooltip>{
                    <div >
                        <Table striped bordered hover size="lg" variant='dark' >
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Amount</th>
                                    <th>Total</th>
                                    <th>Score</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>Category</th>
                                    <td>{rows.supportScore.categoriesCount}</td>
                                    <td>{rows.supportScore.totalCategories}</td>
                                    <td>{rows.supportScore.categorySupportScore}</td>
                                </tr>
                                <tr>
                                    <th>Sales/Total</th>
                                    <td>{PriceFormatter1(rows.supportScore.totalSales)}</td>
                                    <td>{PriceFormatter1(rows.supportScore.totalVendorSales)}</td>
                                    <td>{rows.supportScore.salesSupportScore}</td>
                                </tr>
                            </tbody>
                        </Table>

                    </div>
                }</Tooltip>)}
                    popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="bottom">
                    <Row style={{ width: '100px', flexWrap: 'inherit !important' }}
                        className="ml-2">
                        <div>{(rows.supportScore.salesSupportScore) + (rows.supportScore.categorySupportScore)}</div>
                    </Row>

                </OverlayTrigger>
            )


        } else {
            return <div></div>;
        };

    };

    createCustomClearButtonForBussiness = (onClick) => {
        return (
            <button
                className='btn btn-primary '
                style={{
                    'height': '24px', 'font-size': '11px', 'font-weight': '700',
                    'font-stretch': 'extra-expanded'
                }}
                onClick={(e) => this.getBusinessDefaultData(onClick)}
            >
                Clear All
            </button>
        );
    };

    createCustomClearButtonForMember = (onClick) => {
        return (
            <button
                className='btn btn-primary '
                style={{
                    'height': '24px', 'font-size': '11px', 'font-weight': '700',
                    'font-stretch': 'extra-expanded'
                }}
                onClick={(e) => this.getMemberDefaultData(onClick)}
            >
                Clear All
            </button>
        );
    };

    createCustomClearButtonForProductGroup = (onClick) => {
        return (
            <button
                className='btn btn-primary '
                style={{
                    'height': '24px', 'font-size': '11px', 'font-weight': '700',
                    'font-stretch': 'extra-expanded'
                }}
                onClick={(e) => this.getProductDefaultData(onClick)}
            >
                Clear All
            </button>
        );
    };


    handleRowClickBusiness = row => {

        let params = this.state.params;
        params = paramsToJSON(params);
        params.businessId = row.businessId;
        // params.productGroupId = encodeURIComponent(row.tierFourId);
        params = jsonToParam(params);
        // this.props.getDashboardSalesOpportunityByRegionAPI(params);
        // this.props.getDashboardSalesOpportunityByMemberAPI(params);
        this.props.getVendorOpportunityByCategoryDataAPI(params);

    }
    getBusinessDefaultData = (onClick) => {
        onClick();

        this.refs.table.cleanSelected();
        this.refs.table1.cleanSelected();
        this.refs.table2.cleanSelected();
        let params = this.state.params;
        params = paramsToJSON(params);
        params.businessId = "";
        params.region = "";
        params.tier2 = "";
        params.memberId = "";
        params = jsonToParam(params);
        this.setState({ params: params, })
        this.props.getDashboardSalesOpportunityByRegionAPI(params);
        this.props.getDashboardSalesOpportunityByBusinessAPI(params);
        this.props.getDashboardSalesOpportunityByMemberAPI(params);
        this.props.getVendorOpportunityByCategoryDataAPI(params);
        this.refs.table.reset();
        this.refs.table1.reset();
        this.refs.table2.reset();
    }

    renderDashboardSalesOpportunityByBusiness() {
        this.salesOpportunityByBusiness = [];
        const options = {
            onRowClick: this.handleRowClickBusiness,
            sizePerPageDropDown: this.renderSizePerPageDropDown,
            clearSearch: true,
            clearSearchBtn: this.createCustomClearButtonForBussiness,
            // paginationShowsTotal: this.renderPaginationShowsTotal,
            // sizePerPage: 100,
        }
        return (
            <div className="" >
                <div className="card-deck">
                    <div className="card shadow-sm mb-3">
                        <div className="card-body" style={{ maxHeight: " 356" }}>
                            <h5 style={{ textDecorationLine: 'underline', }}> Sales Opportunity by Business Group</h5>

                            <BootstrapTable search pagination options={options} ref='table1' selectRow={this.selectRowProp} height='338' data={this.props.salesOpportunityByBusiness} striped hover version="4">
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="80px" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} hidden dataField='businessId'></TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="150px" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='businessName' isKey></TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="140px" dataSort={true} dataFormat={this.ProgressBarBusiness} dataField='opportunity'></TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderDashboardScoreData() {
        const options = {
            sizePerPageDropDown: this.renderSizePerPageDropDown,
            clearSearch: true,
            clearSearchBtn: this.createCustomClearButtonForBussiness,
            // paginationShowsTotal: this.renderPaginationShowsTotal,
            // sizePerPage: 100,
        }
        return (
            <div className="" >
                <div className="card-deck">
                    <div className="card shadow-sm mb-3">
                        <div className="card-body" style={{ maxHeight: " 356" }}>
                            <h5 style={{ textDecorationLine: 'underline', }}> Member Support Score</h5>

                            <BootstrapTable search pagination options={options} ref='table3' height='338' data={this.state.scoreColumnsRows} striped hover version="4">
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="90px" dataSort={true} isKey dataField='memberName'>Member Name</TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="120px" dataSort={true} dataFormat={PriceFormatter} dataField='Purchase'>Purchases($)</TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="100px" dataSort={true} dataField='FinalRank'>Member Support Score</TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    handleRowClickproduct = row => {

        let params = this.state.params;
        params = paramsToJSON(params);
        params.tier2 = row.tierFourId;
        params = jsonToParam(params);
        this.props.getDashboardSalesOpportunityByRegionAPI(params);
        this.props.getDashboardSalesOpportunityByMemberAPI(params);
        this.props.getDashboardSalesOpportunityByBusinessAPI(params);

    }
    getProductDefaultData = (onClick) => {
        onClick();
        this.refs.table.cleanSelected();
        this.refs.table1.cleanSelected();
        this.refs.table2.cleanSelected();
        let params = this.state.params;
        params = paramsToJSON(params);
        params.tier2 = "";
        params.region = "";
        params.businessId = "";
        params.memberId = "";
        params = jsonToParam(params);
        this.setState({ params: params, })
        this.props.getDashboardSalesOpportunityByRegionAPI(params);
        this.props.getDashboardSalesOpportunityByBusinessAPI(params);
        this.props.getDashboardSalesOpportunityByMemberAPI(params);
        this.props.getVendorOpportunityByCategoryDataAPI(params);
        this.refs.table.reset();
        this.refs.table1.reset();
        this.refs.table2.reset();
    }

    renderDashboardSalesOpportunityByProductCategory() {
        this.vendorOpportunityByCategory = [];
        // const options = {
        //     onRowClick: this.handleRowClickproduct
        // }
        const options = {
            //onRowClick: this.handleRowClickMember
            onRowClick: this.showProductListModal,
            sizePerPageDropDown: this.renderSizePerPageDropDown,
            clearSearch: true,
            clearSearchBtn: this.createCustomClearButtonForProductGroup,
            // paginationShowsTotal: this.renderPaginationShowsTotal,
            // sizePerPage: 100,
        }
        return (
            <div className="" >
                <div className="card-deck">
                    <div className="card shadow-sm mb-3">
                        <div className="card-body" style={{ maxHeight: " 356" }}>
                            <h5 style={{ textDecorationLine: 'underline', }}> Sales Opportunity by Product Group</h5>
                            {/* <button className="btn btn-primary" style={{ float: "right", marginTop: "2px" }} onClick={this.getProductDefaultData} > Clear All </button>
                            */}
                            <BootstrapTable pagination options={options} search height='338' ref="table2" data={this.props.vendorOpportunityByCategory} striped hover version="4" tableHeaderClass='columnClassNameFormat1'>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="80px" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} hidden dataField='tierFourId'>VendorId</TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="150px" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='tierFour' isKey></TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="140px" dataSort={true} dataFormat={this.ProgressBarProductGroup} dataField='missedOpportunity'></TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    showProductFeedbackIcon = (cell, row) => {
        //;
        return (
            <OverlayTrigger overlay={(<Tooltip id="hi">Feedback for {row.outVendorName}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                <Link onClick={(e) => {
                    e.preventDefault();
                    this.showProductFeedbackModal(row)
                }}> < i className="fas fa-comment-alt"></i></Link>
            </OverlayTrigger>
        )
    }
    showProductFeedbackModal = (row) => {
        //;
        this.setState({
            productId: row.productId, productName: row.productDescription,
            productGroupId: row.productGroupId, productDesc: row.productName,
            productGroupName: row.productGroupName, outVendorName: row.outVendorName, productDescription: row.productDescription,
            showProductFeedbackModal: true, showPopUpForProductFedbackDetails: true
        });

    }
    closeProductFeedbackModal = () => {
        this.setState({ showPopUpForProductFedbackDetails: false, showProductFeedbackModal: false });
        this.refs.comment.value = '';
    }
    handleOnChange(event) {
        this.setState({
            textareaValue: event.target.value
        })
        this.refs.comment.value = '';
    }
    handleCategoryClick = (e, value) => {
        let arr = [];
        let arr1 = [];
        let valuestr = [value.value];
        if (valuestr > 0) {
            let valueee = valuestr.map((option, index) => {
                let val = _find(value.options, ['value', option])
                arr.push(val.value)
                arr1.push(val.text)
            })


        }
        this.setState({ suggestedCategoryId: encodeURIComponent(arr), suggestedCategoryName: encodeURIComponent(arr1), selectFavorableVpErrorMessage: '' })

    }
    sendProductFeedback() {
        //  ;
        let selections = {
            productId: this.state.productId,
            productDesc: this.state.productName,
            categoryId: this.state.productGroupId,
            categoryName: this.state.productGroupName,
            feedbackComment: this.state.textareaValue,
            productCategoryWrong: this.state.feedbackToggleForWrongClassification,
            suggestedCategoryId: this.state.suggestedCategoryId,
            suggestedCategoryName: this.state.suggestedCategoryName,
        }

        if (!this.state.suggestedCategoryName) {
            this.setState({ selectCategoryErrorMessage: 'Please select a Category' }, () => {
            });
        } else {
            this.setState({ showPopUpForProductFedbackDetails: false, textareaValue: '', feedbackComment: '', showProductFeedbackModal: false, selectCategoryErrorMessage: '' }, () => {
                this.props.saveProductFeedbackAPI(selections, (res) => {

                    swal(res.data.text);

                    this.refs.comment.value = '';
                    this.state.textareaValue = '';

                });

            });
        }
    }

    render() {
        let addModalClose = () => this.setState({ addModalShow: false });

        let growthRebateExcelData = [];
        this.props.vendorGroupGrowth.forEach(row => {
            row.criteria.forEach((criteira, index) => {
                growthRebateExcelData.push({
                    ...row,
                    criteria: criteira,
                    currentYearSales: row.currentYearSales[index],
                    targetSales: row.targetSales[index],
                    gapAmount: row.gapAmount[index],
                    attainmentPercent: Number(row.attainmentPercent[index]).toFixed(1)
                });
            });
        });
        console.log('this is inside render ', this.state);
        const data = {
            columns: [
                ['data1', 30, 200, 100, 400, 150, 250],
                ['data2', 50, 20, 10, 40, 15, 25]
            ]
        };
        let overallCardSection = [];
        this.props.getVendorSalesRebatCardData.map((card, index) => {
            let str = accounting.formatMoney(card.value);
            str = str.slice(0, -3);
            let str1 = accounting.formatMoney(card.lastYearValue);
            str1 = str.slice(0, -3);
            let yoy = '';
            // ;
            if ((card.lastYearValue) != 0) {
                yoy = ((((card.value) - (card.lastYearValue)) / (card.lastYearValue)) * 100)
            } else {
                yoy = 'NA'
            }
            overallCardSection.push(
                <GrayCard
                    // style={{ width: '50%', display: 'inline-block',paddingLeft:'0px !important',paddingRight:'25px !important' }}
                    displayModal={this.displayModalMethod}
                    closeModal={this.closeModal}
                    type={"amount"}
                    title={getCardTitle(card.cardTitle)}
                    amount={str}
                    updatedDate={card.updateDate}
                    growthAmount={yoy}
                    growth={yoy >= 0 ? "positive" : "negative"}
                />
            )
        })

        if (_isEmpty(overallCardSection)) {
            overallCardSection.push(
                <div className="col-sm-3 errorText">No data available</div>
            )
        }

        // vendor verified data comparison graph 
        let comparisonchart = {
            data: {
                x: 'x',

                columns: [

                    ['x', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],

                    ['data1', 10000, 12000, 20000, 24000, 28000, 32000, '', '', '', '', '', ''],
                    ['data2', 13000, 15000, 22000, 24000, 26000, 30000, '50000', '55000', '58000', '65000', '70000', '80000']


                ],
                type: 'bar',
                types: {
                    data1: 'bar',
                    data2: 'bar',
                },
                axes: {
                    data1: 'y',
                    data2: 'y2'
                },
                names: {
                    data1: "2021 Sales",
                    data2: "2020 Sales"
                }
            },
            bar: {
                width: {
                    ratio: 0.2, // this makes bar width 50% of length between ticks
                }
            },
            axis: {
                x: {
                    type: 'category',
                    label: 'Month',
                    show: true,

                },
                y: {
                    label: 'Sales ',
                    show: true,
                    tick: {
                        format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
                        //                format: function (d) { return "$" + d; }
                    }
                },
                y2: {
                    // label: 'SalesOpportunity',
                    // show: true,
                    tick: {
                        format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
                        //                format: function (d) { return "$" + d; }
                    }
                }
            }
        };



        // Overview graph 
        let dataForChart = {
            data: {
                x: 'x',

                columns: [

                    ['x', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],

                    this.props.salesOpportunity.chartData1,
                    this.props.salesOpportunity.chartData2,
                    this.props.salesOpportunity.chartData3,

                ],
                names: {
                    data1: "Verified Total Sales ($)",
                    data2: "Sales Opportunity ($)",
                    data3: "Supplier Total Sales ($)"
                }
            },

            axis: {
                x: {
                    label: "Month",
                    type: 'category'
                },
                y: {
                    label: 'Volume',
                    tick: {
                        format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
                        //                format: function (d) { return "$" + d; }
                    }
                },
                y2: {
                    label: 'VP Monthly',
                    show: false,
                    tick: {
                        format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
                        //                format: function (d) { return "$" + d; }
                    }
                }
            }
        };
        // graph ended 

        /* Member purchase Graph*/
        let GraphdataForChart = {
            data: {
                x: 'x',

                columns: [

                    ['x', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],

                    this.props.PurchasesGraphData.GraphchartData1,
                    this.props.PurchasesGraphData.GraphchartData2,
                    //this.props.PurchasesGraphData.GraphchartData3,

                ],
                type: 'bar',
                // types: {
                //     data1: 'bar',
                //     data2: 'bar',
                // },
                // axes: {
                //     data1: 'y',
                //     data2: 'y2'
                // },
                names: {
                    data1: "Current Year Sales($)",
                    data2: "Last Year Sales($)"
                }
            },
            bar: {
                width: {
                    ratio: 0.2, // this makes bar width 50% of length between ticks
                }
            },
            axis: {
                x: {
                    label: "Month",
                    type: 'category'
                },
                y: {
                    label: 'Sales ',
                    // show: true,
                    tick: {
                        format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
                        //                format: function (d) { return "$" + d; }
                    }
                },
                y2: {
                    label: 'Sales ',
                    show: false,

                    tick: {
                        format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
                        //                format: function (d) { return "$" + d; }
                    }

                }
            }
        };


        /**/

        this.getProductListVendorDashboard = [];
        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
        const optionsProduct = {
            sizePerPageDropDown: this.renderSizePerPageDropDown
            // paginationShowsTotal: this.renderPaginationShowsTotal,
            // sizePerPage: 100,
        }
        const { showQuarter } = this.state;
        const { monthName } = this.props;
        let params = this.state.params;
        params = paramsToJSON1(params);

        return (
            <div>
                {this.hideRegionTip()}
                <nav className="Filters navbar">
                    <div style={{ marginLeft: "60px" }}>
                        {this.state.addModalShow1 == true ?
                            <span className="navbar-brand nav-head">{sessionStorage.getItem('imark-vendorName')}  (Non-Compliant Supplier) </span>
                            :
                            <span className="navbar-brand nav-head">{sessionStorage.getItem('imark-vendorName')}  (Compliant Supplier) </span>
                        }</div>
                    <ul className="navbar-nav flexRowForFilters2" >

                        <li className="nav-item">
                            <div className="btn-group">
                                {this.renderButtonGroup()}
                            </div>
                        </li>
                        <li className="nav-item">
                            <Select onChange={(e) => this.handleChangeOfDropdownYear(e)}
                                value={this.state.selectedYear}
                                options={this.state.yearval} />
                        </li>
                        {showQuarter ?
                            <li className="nav-item">
                                <select className="form-control" style={{ height: '38px', width: '80px' }} onChange={(e) => { this.handleChangeOfDropdown({ name: "quarter", value: e.target.value }) }} >
                                    <option value="1" selected={params.quarter == 1 ? true : false} >QTR1</option>
                                    <option value="2" selected={params.quarter == 2 ? true : false} >QTR2</option>
                                    <option value="3" selected={params.quarter == 3 ? true : false} >QTR3</option>
                                    <option value="4" selected={params.quarter == 4 ? true : false} >QTR4</option>
                                </select>

                            </li>
                            :
                            <li className="nav-item">
                                <Select
                                    onChange={(e) => this.handleChangeOfDropdownMonth(e)}
                                    autosize={true}
                                    value={this.state.selectedItem}
                                    options={this.state.items} />

                            </li>
                        }


                    </ul>

                    <ExcelFile filename="SUPPLIER DATA" element={<button className="btn btn-primary" style={{ marginRight: "60px", height: '38px' }}>Export</button>}>

                        <ExcelSheet data={growthRebateExcelData} name="GROWTH REBATE VALUES">
                            <ExcelColumn label="SUPPLIER ID" value="vendorId" />
                            <ExcelColumn label="SUPPLIER NAME" value="vendorName" />
                            <ExcelColumn label="CRITERIA" value="criteria" />
                            <ExcelColumn label="LEVEL" value="tier" />
                            <ExcelColumn label="ACTUAL SALES" value="currentYearSales" />
                            <ExcelColumn label="TARGET SALES($)" value="targetSales" />
                            <ExcelColumn label="GAP ($)" value="gapAmount" />
                            <ExcelColumn label="ATTAINMENT (%)" value="attainmentPercent" />
                            <ExcelColumn label="REBATE ($)" value="rebateAmount" />
                            <ExcelColumn label="REBATE (%)" value="rebatePercent" />

                        </ExcelSheet>
                        <ExcelSheet data={this.props.rebatesOverview} name="SALES AND REBATES OVERVIEW">
                            <ExcelColumn label="MEMBER NAME" value="memberName" />
                            <ExcelColumn label="IMARK LAST BILLED DATE" value="imarkLastBilledDate" />
                            <ExcelColumn label="SUPPLIER LAST BILLED DATE" value="vendorLastBilledDate" />
                            <ExcelColumn label="IMARK SALES" value="verifiedSales" />
                            <ExcelColumn label="SUPPLIER SALES" value="vendorSales" />
                            <ExcelColumn label="IMARK BASE REBATE" value="verifiedFlatRebate" />
                            <ExcelColumn label="SUPPLIER BASE REBATE" value="vendorFlatRebate" />
                            <ExcelColumn label="IMARK FBI REBATE" value="verifiedFbiRebate" />
                            <ExcelColumn label="SUPPLIER FBI REBATE" value="vendorFbiRebate" />
                            <ExcelColumn label="IMARK TOTAL REBATE" value="verifiedTotalRebate" />
                            <ExcelColumn label="SUPPLIER TOTAL REBATE" value="vendorTotalRebate" />
                        </ExcelSheet>

                        <ExcelSheet data={this.props.getDashboardSalesOpportunityByMember} name="SALES OPPORTUNITY BY MEMBER">
                            <ExcelColumn label="MEMBER NAME" value="memberName" />
                            {/* <ExcelColumn label="MISSED OPPORTUNITY" value="missedOpportunity" /> */}
                        </ExcelSheet>
                    </ExcelFile>

                </nav>
                {this.state.isLoading ? matLoader() : <div>

                    <div className="row" style={{ paddingBottom: "12px", paddingTop: "0px", background: " #fff", boxShadow: "0 1px 4px rgba(0, 0, 0, 0.3)", maxHeight: "420px", padding: "10px", marginLeft: "60px", marginRight: "60px" }}>

                        <div className="col-sm-5" style={{ marginBottom: "10px" }}>

                            {/* <span>Rebate Overview</span> */}
                            {overallCardSection}
                        </div>


                        <div className="col-sm-7">
                            <C3Chart data={dataForChart.data} axis={dataForChart.axis} />
                        </div>


                    </div>

                    {/* Moved opportunity tab to toUpperCase */}
                    <div class="row" style={{ paddingBottom: "12px", paddingTop: "2rem", marginLeft: "60px", marginRight: "60px" }}>
                        <div className="col-6">
                            <div className="card-deck">
                             
                                <div className="card shadow-sm mb-3">
                                    <div className="card-body" style={{ maxHeight: " 260" }}>
                                        <h5 style={{ textDecorationLine: 'underline', }}>Sales Opportunity by Region123</h5>
                                       
                                        {this.renderVectorMap()}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            {this.renderDashboardSalesOpportunityByMember()}
                        </div>
                    </div>

                    <div className="row" style={{ paddingBottom: "12px", paddingTop: "0", marginTop: "20px", marginLeft: "60px", marginRight: "60px" }}>
                        <div className="col-6">
                            {this.renderDashboardSalesOpportunityByBusiness()}
                        </div>
                        <div className="col-6">
                            {this.renderDashboardSalesOpportunityByProductCategory()}
                        </div>
                       
                    </div> 

                    {/* //ended  */}

                    <div className="row" style={{ marginTop: "2rem", background: " #fff", boxShadow: "0 1px 4px rgba(0, 0, 0, 0.3)", maxHeight: "400", padding: "10px", marginLeft: "60px", marginRight: "60px" }}>
                        <div className="col-12">
                            <div className="rowC">
                                <h3>Group Growth Rebate</h3>
                            </div>
                            <div>
                                <BootstrapTable search height='300' data={this.props.vendorGroupGrowth} striped hover version="4">
                                    <TableHeaderColumn width="100" tdStyle={{ whiteSpace: 'normal' }} isKey dataSort={true} dataField='vendorId'>Id</TableHeaderColumn>
                                    <TableHeaderColumn width="160" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='vendorName'>Supplier</TableHeaderColumn>

                                    <TableHeaderColumn width="150" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='programName'>Program</TableHeaderColumn>
                                    <TableHeaderColumn width="130" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataFormat={this.TierCriteria} dataField='criteria'>Criteria</TableHeaderColumn>
                                    <TableHeaderColumn width="90" tdStyle={{ whiteSpace: 'normal' }} dataFormat={this.TierComponent} dataSort={true} dataField='tier'>Level</TableHeaderColumn>
                                    <TableHeaderColumn width="130" tdStyle={{ whiteSpace: 'normal', wordBreak: 'break-all', overflowWrap: 'break-word' }} bodyStyle={{ width: 500, maxWidth: 500, wordBreak: 'break-all' }} dataFormat={this.PoundSalesCalculation} dataSort={true} dataField='currentYearSales'>Actual Volume</TableHeaderColumn>
                                    <TableHeaderColumn width="120" tdStyle={{ whiteSpace: 'normal' }} dataFormat={this.PoundCurrencyTargetCalculation} dataSort={true} dataField='targetSales'>Target Volume</TableHeaderColumn>
                                    <TableHeaderColumn width="120" tdStyle={{ whiteSpace: 'normal' }} dataFormat={this.PoundCurrencyGapCalculation} dataSort={true} dataField='gapAmount'>GAP</TableHeaderColumn>
                                    <TableHeaderColumn width="100" tdStyle={{ whiteSpace: 'normal' }} dataFormat={this.AttainmentComp} dataSort={true} dataField='attainmentPercent'>Attainment(%)</TableHeaderColumn>
                                    <TableHeaderColumn width="100" tdStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='rebateAmount'>REBATE ($)</TableHeaderColumn>
                                    <TableHeaderColumn width="100" dataFormat={PercentFormatter} dataSort={true} dataField='rebatePercent'>REBATE (%)</TableHeaderColumn>
                                </BootstrapTable>
                            </div>
                            <div class="card-footer" style={{ textAlign: 'center' }}>
                                All Records Are YTD Till {monthName1(this.state.selectedItem.label)}, {params.year}
                            </div>



                        </div>
                    </div>
                   
                    <div className="row" style={{ marginTop: "2rem", background: " #fff", boxShadow: "0 1px 4px rgba(0, 0, 0, 0.3)", maxHeight: "400", padding: "10px", marginLeft: "60px", marginRight: "60px" }}>
                        <div className="col-12">
                            <div className="rowC">
                                <h3>Growth Rebate Individual Level</h3>
                            </div>
                            <div>
                                <BootstrapTable search height='300' data={this.props.getDashboardIndividualGrowthRebate} striped hover version="4">
                                    <TableHeaderColumn width="120" tdStyle={{ whiteSpace: 'normal' }} isKey="true" dataSort={true} dataField='programName'>Program</TableHeaderColumn>
                                    <TableHeaderColumn width="120" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='memberName'>Member</TableHeaderColumn>
                                    <TableHeaderColumn width="150" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataFormat={this.GrowthTier} dataField='rebateTierVendor'>Individual Growth(Supplier) </TableHeaderColumn>
                                    <TableHeaderColumn width="150" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataFormat={this.GrowthTierVerified} dataField='rebateTierVerified'>Individual Growth(Verified)</TableHeaderColumn>
                                    
                                    <TableHeaderColumn width="100" dataFormat={this.RebateVerified} dataSort={true} dataField='rebatePercent'>REBATE (%)</TableHeaderColumn>
                                    <TableHeaderColumn width="100" dataFormat={PriceFormatter} tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='rebate'>REBATE ($)</TableHeaderColumn>
                                </BootstrapTable>
                            </div>
                            <div class="card-footer" style={{ textAlign: 'center' }}>
                                All Records Are YTD Till {monthName1(this.state.selectedItem.label)}, {params.year}
                            </div>



                        </div>
                    </div>


                    <div className="row" style={{ marginTop: "2rem", background: " #fff", boxShadow: "0 1px 4px rgba(0, 0, 0, 0.3)", padding: "10px", marginLeft: "60px", marginRight: "60px" }}>
                        <div className="col-12">
                            <div className="rowC">
                                <h3>Sales and rebate Overview</h3>
                            </div>
                            <div>
                                <BootstrapTable height='350' data={this.props.rebatesOverview} search striped hover version="4">
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal', backgroundColor: '#ccc', position: 'sticky', left: 0, zIindex: 1 }} tdStyle={{ whiteSpace: 'normal', backgroundColor: '#ccc', position: 'sticky', left: 0, zIindex: 1 }} width="120px" dataSort={true} isKey dataField='memberId'>Member Id</TableHeaderColumn>
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal', backgroundColor: '#ccc', position: 'sticky', left: 120, zIindex: 2 }} tdStyle={{ whiteSpace: 'normal', backgroundColor: '#ccc', position: 'sticky', left: 120, zIindex: 2 }} width="120px" dataSort={true} dataField='memberName'>Member  Name</TableHeaderColumn>
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal', backgroundColor: '#ccc', position: 'sticky', left: 240, zIindex: 3 }} tdStyle={{ whiteSpace: 'normal', backgroundColor: '#ccc', position: 'sticky', left: 240, zIindex: 3 }} width="120px" dataSort={true} dataFormat={this.MemberScore}  dataField='supportScore.salesSupportScore'>Member Support Score(Scale:0-10)</TableHeaderColumn>
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="95px" dataSort={true} dataFormat={DateFormatter} dataField='imarkLastBilledDate'>IMARK Last Transaction Date</TableHeaderColumn>
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="100px" dataSort={true} dataFormat={DateFormatter} dataField='vendorLastBilledDate'>Supplier Last Transaction Date</TableHeaderColumn>
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} width="100px" dataSort={true} dataField='verifiedSales'>IMARK Sales</TableHeaderColumn>
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} width="110px" dataSort={true} dataField='vendorSales'>Supplier Sales</TableHeaderColumn>
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="140px" dataFormat={PriceFormatter} dataSort={true} dataField='verifiedFlatRebate'>IMARK Base Rebate</TableHeaderColumn>
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="149px" dataFormat={PriceFormatter} dataSort={true} dataField='vendorFlatRebate'>Supplier Base Rebate</TableHeaderColumn>
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} width="132px" dataSort={true} dataField='verifiedFbiRebate'>IMARK FBI Rebate</TableHeaderColumn>
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="140px" dataFormat={PriceFormatter2}  dataSort={true} dataField='vendorFbiRebate'>Supplier FBI Rebate</TableHeaderColumn>
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} width="130px" dataSort={true} dataField='verifiedTotalRebate'>IMARK Total Rebate</TableHeaderColumn>
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} width="130px" dataSort={true} dataField='vendorTotalRebate'>Supplier Total Rebate</TableHeaderColumn>
                                </BootstrapTable>
                            </div>


                        </div>

                    </div>
                    {/* New additon on 20/05/2020 (score implementation) */}

                    {/* <div className="row" style={{ marginTop: "2rem", background: " #fff", boxShadow: "0 1px 4px rgba(0, 0, 0, 0.3)", padding: "10px", marginLeft: "60px", marginRight: "60px" }}>
                        <div className="col-12">
                            <div className="rowC">
                                <h3>Member Support Score</h3>
                            </div>
                            <div>
                                <BootstrapTable height='350' data={this.state.scoreColumnsRows} search striped hover version="4">
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="60px" dataSort={true} isKey dataField='memberId'>Member Id</TableHeaderColumn>
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="100px" dataSort={true} dataField='memberName'>Member Name</TableHeaderColumn>
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="90px" dataSort={true} dataFormat={PriceFormatter} dataField='Purchase'>Purchases($)</TableHeaderColumn>
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="110px" dataSort={true} dataField='Categories'>Member Categories</TableHeaderColumn>
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }}  width="140px" dataSort={true} dataField='SalesRank'>Sales Support Score</TableHeaderColumn>
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="140" dataSort={true} dataField='CategoryRank'>Category Support Score</TableHeaderColumn>
                                    <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="140px" dataSort={true} dataField='FinalRank'>Member Support Score</TableHeaderColumn>

                                </BootstrapTable>
                            </div>


                        </div>

                    </div> */}

                    <div className="row" style={{ marginTop: "2rem", background: " #fff", boxShadow: "0 1px 4px rgba(0, 0, 0, 0.3)", padding: "10px", marginLeft: "60px", marginRight: "60px" }}>
                        <div className="col-12">
                            <div className="rowCA">
                                <div className="col-9">

                                <span style={{marginRight:"0.5rem",fontSize:'larger'
                                        }}>
                                       Member Rebatable Sales (Supplier Data)</span>
                                       <span style={{marginRight:"0.5rem",
                                        marginLeft:"1rem"}}>
                                        Supplier Last Upload Date : </span> 

                           <span style={{marginRight:"0.5rem"}}> {this.props.vendordate ? new Date(this.props.vendordate).toLocaleDateString('en-US'):''}</span>                                 
                         <span style={{marginRight:"0.5rem",
                                        marginLeft:"1rem"}}>
                     {this.props.memberdate1 ?"Member Last Recieved Date : " + 
                                         new Date(this.props.memberdate1).toLocaleDateString('en-US'):''}
                                </span>
                                </div>
                                <div className="col-3">
                                    <Dropdown style={{marginRight:"0.5rem",}} ref ="memberListvalue" clearable onChange={(e, value) => this.handleClickMemberFull(e, value)}
                                        placeholder='Select Member' search fluid selection options={this.props.memberNamesListFull} />


                                </div>
                            </div>
                            <div>
                                <C3Chart data={GraphdataForChart.data} axis={GraphdataForChart.axis} />

                            </div>


                        </div>

                    </div>




                    {/*  ended score implementation */}

                    {/* */}

                </div>}
                {this.state.showProductListModalPopUp ?
                    <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block" }}>

                        <div className="modal-dialog" role="document" style={{ minWidth: "700px" }}>

                            <div className="modal-content" style={{ width: "700px" }}>

                                <div className="modal-header">
                                    <h5 className="modal-title" >Product List for {this.state.productGroupName}</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { this.closeProductListModal() }} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body" >

                                    <ExcelFile element={<button className="btn btn-primary" style={{ marginLeft: "500px" }} >Download Product Names</button>}>
                                        <ExcelSheet data={this.props.getProductListVendorDashboard} name="Group Rebates">
                                            <ExcelColumn label="PRODUCT NAME" value="productDescription" />
                                            <ExcelColumn label="MANUFACTURER NAME" value="vendorUnapprovedName" />
                                        </ExcelSheet>
                                    </ExcelFile>

                                    <BootstrapTable options={optionsProduct} pagination height='350' data={this.props.getProductListVendorDashboard} striped hover version="4">
                                        {/* <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="90px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} isKey dataField='productId'>Product Id</TableHeaderColumn> */}
                                        <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="200px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} isKey dataField='productDescription'>Product Name</TableHeaderColumn>
                                        <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="200px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='vendorUnapprovedName'>Manufacturer Name</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="140px" dataSort={true} dataFormat={this.ProgressBarProductGroupDetails} dataField='missedSalesAmount'></TableHeaderColumn>
                                        <TableHeaderColumn dataFormat={this.showProductFeedbackIcon} width="80px" dataField='feedback'>Feedback</TableHeaderColumn>
                                        <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="140px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} hidden dataField='outVendorName'>Outside Supplier</TableHeaderColumn>
                                        <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="140px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} hidden dataField='favorableVendor'>Favorable Supplier </TableHeaderColumn>
                                        <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="130px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} hidden dataField='productGroupId'> </TableHeaderColumn>
                                        <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="180px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} hidden dataFormat={PriceFormatter} dataField='outsidePurchase'> PURCHASES OUTSIDE($) </TableHeaderColumn>
                                        <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="100px" thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} hidden dataSort={true} dataField='rebateOpportunity'>REBATE($) </TableHeaderColumn>
                                        <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="100px" thStyle={{ whiteSpace: 'normal' }} dataFormat={PercentFormatter} hidden dataSort={true} dataField='rebatePercent'>REBATE(%)</TableHeaderColumn>
                                    </BootstrapTable>
                                    <div >

                                        <span className="errorText">{ }</span>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button type="button" onClick={(e) => { this.closeProductListModal() }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div> : ''
                }
                {this.state.showPopUpForProductFedbackDetails ?
                    <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block" }}>

                        <div className="modal-dialog" role="document" style={{ minWidth: "100px" }}>

                            <div className="modal-content" style={{ width: "700px" }}>

                                <div className="modal-header">
                                    <h5 className="modal-title" >Product Feedback</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { this.closeProductFeedbackModal() }} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body" >
                                    <div >
                                        <form>
                                            <div className="form-group feedbackToggle">
                                                <label >Is {this.state.productDesc} wrongly classified as {this.state.selectedCategory}? </label>
                                                <Checkbox toggle onChange={(e, value) => {
                                                    if (value.checked) {
                                                        this.setState({ disableNewProductCategoryDropdown: false, selectCategoryErrorMessage: '' });
                                                    } else {
                                                        this.setState({ disableNewProductCategoryDropdown: true, selectCategoryErrorMessage: '' });
                                                    }
                                                    this.setState({ feedbackToggleForWrongClassification: value.checked });
                                                }} />
                                            </div>
                                            <div className="form-group feedbackToggle">
                                                <Dropdown
                                                    placeholder='Select new Product Category'
                                                    disabled={this.state.disableNewProductCategoryDropdown}
                                                    fluid
                                                    search
                                                    selection
                                                    value={this.props.value}
                                                    options={this.props.ProductCategoryList}
                                                    onChange={(e, value) => this.handleCategoryClick(e, value)}
                                                />
                                            </div>
                                            <div className="form-group feedbackToggle">
                                                <label>Comments</label>
                                                {/* <textarea ref="comment" rows={2} onChange={(e, value) => this.handleOnChange(e, value)} >
                                                    {this.state.textareaValue}</textarea>
                                                */}
                                                <textarea ref="comment" rows={2} cols={20} value={this.state.textareaValue}
                                                    onChange={(e, value) => this.handleOnChange(e, value)} />

                                            </div>

                                        </form>
                                        <span className="errorText">{this.state.selectCategoryErrorMessage}</span>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button type="button" onClick={(e) => { this.sendProductFeedback() }} className="btn btn-primary">Submit</button>
                                    <button type="button" onClick={(e) => { this.closeProductFeedbackModal() }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div> : ''
                }
                <Modelpopup
                    show={this.state.addModalShow}
                    onHide={addModalClose}
                />

            </div>
        )
    }
}

function mapStateToProps(state) {
    let chartData = _get(state, 'vendor.salesOpportunity', []);
    let chartData1Arr = [];
    let chartData2Arr = [];
    let chartData3Arr = [];
    if (!_isEmpty(chartData)) {
        let chartDataForSalesOpportunity = chartData.map((data, index) => {
            chartData1Arr.push(_get(data, 'verifiedTotalSales', ''));
            chartData2Arr.push(_get(data, 'salesOpportunity', ''));
            chartData3Arr.push(_get(data, 'vendorTotalSales', ''));
        })
    }

    chartData1Arr.unshift('data1');
    chartData2Arr.unshift('data2');
    chartData3Arr.unshift('data3');
    /*Graph comparison code */

    let GraphchartData = _get(state, 'vendor.getMemberPurchasesDataa', []);
    let GraphchartData1Arr = [];
    let GraphchartData2Arr = [];
    let GraphchartData3Arr = [];
    let GraphchartData4Arr = [];
    let GraphchartData5Arr = [];

    if (!_isEmpty(GraphchartData)) {
        let chartDataForMemberPurchases = GraphchartData.map((data, index) => {
            GraphchartData1Arr.push(_get(data, 'verifiedSalesCY', ''));
            GraphchartData2Arr.push(_get(data, 'verifiedSalesLY', ''));
            GraphchartData3Arr.push(_get(data, 'memberId', ''));
            GraphchartData4Arr.push(_get(data, 'memberName', ''));
            GraphchartData5Arr.push(_get(data, 'month', ''));
        })
    }

    GraphchartData1Arr.unshift('data1');
    GraphchartData2Arr.unshift('data2');
    GraphchartData3Arr.unshift('data3');
    GraphchartData4Arr.unshift('data4');
    GraphchartData5Arr.unshift('data5');



    console.log('rebate data === ', _get(state, 'member.getRebateViewData', []));
    let rebateTypeNames = [];
    let rebateTypeNameprops = _get(state, 'vendor.vendorOverviewRebateTypeNames', []);
    rebateTypeNameprops && rebateTypeNameprops.map((rebateTypeName, index) => {
        let rebateTypeNameObj = {
            key: index,
            text: rebateTypeName.rebateTypeName,
            value: index
        }
        rebateTypeNames.push(rebateTypeNameObj)
    })
    let rebateTypeNamesFiltered = [];
    let rebateTypeNamesFilteredprops = _get(state, 'vendor.vendorOverviewRebateTypeNamesFiltered', []);
    rebateTypeNamesFilteredprops && rebateTypeNamesFilteredprops.map((rebateTypeName, index) => {
        let rebateTypeNameObj = {
            key: index,
            text: rebateTypeName.rebateTypeName,
            value: index
        }
        rebateTypeNamesFiltered.push(rebateTypeNameObj)
    })
    let sourceNamesFiltered = [];
    let sourceNamesFilteredprops = _get(state, 'vendor.vendorOverviewSourceNamesFiltered', []);
    sourceNamesFilteredprops && sourceNamesFilteredprops.map((sourceName, index) => {
        let sourceNameObj = {
            key: index,
            text: sourceName.source,
            value: index
        }
        sourceNamesFiltered.push(sourceNameObj)
    })
    let sourceNames = [];
    let sourceNameProps = _get(state, 'vendor.vendorOverviewSourceNames', []);
    sourceNameProps && sourceNameProps.map((sourceName, index) => {
        let sourceNameObj = {
            key: index,
            text: sourceName.source,
            value: index
        }
        sourceNames.push(sourceNameObj)
    })
    let bhNames = [];
    let bhNameprops = _get(state, 'vendor.vendorOverviewBHNames', []);
    bhNameprops && bhNameprops.map((bhMember, index) => {
        let bhMemberObj = {
            key: index,
            text: bhMember.memberName,
            value: index
        }
        bhNames.push(bhMemberObj)
    })
    //For ProgressBar
    let chartDataformember = _get(state, 'vendor.getDashboardSalesOpportunityByMember', []);
    let chartDatamemberArr = [];
    if (!_isEmpty(chartDataformember)) {
        chartDataformember.map((data, index) => {
            chartDatamemberArr.push(_get(data, 'missedOpportunity', ''));
        })
    }
    else {
        chartDatamemberArr.push([]);
    }
    let chartDataforvolume = _get(state, 'vendor.salesOpportunityByBusiness', []);
    let chartDatavolumeArr = [];
    if (!_isEmpty(chartDataforvolume)) {
        chartDataforvolume.map((data, index) => {
            chartDatavolumeArr.push(_get(data, 'opportunity', ''));
        })
    }
    else {
        chartDatavolumeArr.push([]);
    }
    let chartDataforpg = _get(state, 'vendor.vendorOpportunityByCategory', []);
    let chartDatapgArr = [];
    if (!_isEmpty(chartDataforpg)) {
        chartDataforpg.map((data, index) => {
            chartDatapgArr.push(_get(data, 'missedOpportunity', ''));
        })
    }
    else {
        chartDatapgArr.push([]);
    }
    let chartDataforpgdetails = _get(state, 'vendor.getProductListVendorDashboard', []);
    let chartDatapgArrdetails = [];
    if (!_isEmpty(chartDataforpgdetails)) {
        chartDataforpgdetails.map((data, index) => {
            chartDatapgArrdetails.push(_get(data, 'missedSalesAmount', ''));
        })
    }
    else {
        chartDatapgArrdetails.push([]);
    }
    let ProductCategory = [];
    // ;
    let ProductCategoryprops = _get(state, 'corporate.getProductCategorycorporate', []);
    ProductCategoryprops && ProductCategoryprops.map((vname, index) => {
        //;
        let ProductCategoryObj = {
            key: index,
            text: vname.productCategory,
            value: vname.productCategoryId,
        }
        ProductCategory.push(ProductCategoryObj)
        // ;
    })
    let memberNames1 = [];
    let MemberNameprops1 = _get(state, 'vendor.getMemberList', []);
    let memberdate = [];
    let memberId = [];
    let memberdatavalue = [];
;
    MemberNameprops1 && MemberNameprops1.map((mname, index) => {
        let memberNameObj1 = {
            key: index,
            text: mname.memberName,
            value: mname.memberId
        }
        memberNames1.push(memberNameObj1)

    })

    if (!_isEmpty(MemberNameprops1)) {
        let memberdatavalue = MemberNameprops1.map((data, index) => {
            memberdate.push(_get(data, 'updateDate', ''));
            memberId.push(_get(data, 'memberId', ''));

        })
    }    
     memberdate.unshift('data');
     memberId.unshift('data');

 let vendordate =[];
 let memberdate1= [];
 let data1=[];
     let date = _get(state, 'vendor.getMemberVendorDate', []);
     memberdate1 = (_get(date, 'memberUpdateDate', ''));
     vendordate = (_get(date, 'vendorUpdateDate', ''));

//      if (!_isEmpty(date)) {
// 
//         Object.keys(date).forEach( function (key) {
            
//   vendordate = date[key];
//  // memberdate1 = date[key];
   
//  }) 
//     }

    return {
        vendordate:vendordate,
        memberdate1:memberdate1,
       // memberdate: memberdatavalue,
        memberNamesListFull: memberNames1,
        MemberList: chartDatamemberArr,
        VolumeList: chartDatavolumeArr,
        PGList: chartDatapgArr,
        ProductCategoryList: ProductCategory,
        CategoryList: chartDatapgArrdetails,
        salesOpportunity: {
            chartData1: chartData1Arr,
            chartData2: chartData2Arr,
            chartData3: chartData3Arr,
        },
        PurchasesGraphData: {
            GraphchartData1: GraphchartData1Arr,
            GraphchartData2: GraphchartData2Arr,
            GraphchartData3: GraphchartData3Arr,
            GraphchartData4: GraphchartData4Arr,
            GraphchartData5: GraphchartData5Arr,
        },
        sourceNamesFilteredList: sourceNamesFiltered,
        vendorOverviewRebateTypeNamesFilteredList: rebateTypeNamesFiltered,
        bhNamesList: bhNames,
        rebateTypeNamesList: rebateTypeNames,
        sourceNamesList: sourceNames,
        getVendorSalesRebatCardData: _get(state, 'vendor.getVendorSalesRebatCardData', []),
        rebateCards: _get(state, "vendor.rebateCards", []),
        rebatesOverview: _get(state, 'vendor.vendorRebatesOverview', []),
        salesOpportunityByRegion: _get(state, 'vendor.salesOpportunityByRegion', []),
        vendorOpportunityByCategory: _get(state, 'vendor.vendorOpportunityByCategory', []),
        getDashboardSalesOpportunityByMember: _get(state, 'vendor.getDashboardSalesOpportunityByMember', []),
        salesOpportunityByBusiness: _get(state, 'vendor.salesOpportunityByBusiness', []),
        getProductListVendorDashboard: _get(state, 'vendor.getProductListVendorDashboard', []),
        vendorGroupGrowth: _get(state, 'vendor.vendorGroupGrowth', []),
        getDashboardIndividualGrowthRebate: _get(state, 'vendor.getDashboardIndividualGrowthRebate', []),
        //vendorIdForCorporate: _get(window.sessionStorage, 'imark-vendorId', ''),
        vendorIdForCorporate: window.sessionStorage.getItem('imark-vendorId'),
        stateRegionMapping: _get(state, 'corporate.stateRegionMapping', []),
        stateToStateMapping: _get(state, 'corporate.stateToStateMapping', []),
        saveProductFeedbackAPI: _get(state, 'member.saveProductFeedback', []),
        getVendorMonthsFilter: _get(state, 'vendor.getVendorMonthsFilter', []),
        getMemberPurchasesData: _get(state, 'vendor.getMemberPurchasesData', []),

        getMemberList: _get(state, 'vendor.getMemberList', []),

        tabTracking: _get(state, 'corporate.tabTracking', []),
        getMemberVendorDate:_get(state,'vendor.getMemberVendorDate'),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getVendorSalesRebatCardDataAPI: getVendorSalesRebatCardData,
        getDashboardRebatesOverviewAPI: getDashboardRebatesOverview,
        getDashboardSalesOpportunityGraphAPI: getDashboardSalesOpportunityGraph,
        getDashboardSalesOpportunityByRegionAPI: getDashboardSalesOpportunityByRegion,
        getDashboardSalesOpportunityByMemberAPI: getDashboardSalesOpportunityByMember,
        getDashboardSalesOpportunityByBusinessAPI: getDashboardSalesOpportunityByBusiness,
        getVendorOpportunityByCategoryDataAPI: getVendorOpportunityByCategoryData,
        getDashboardGrowthRebateAPI: getDashboardGrowthRebate,
        getDashboardIndividualGrowthRebateAPI: getDashboardIndividualGrowthRebate,
        getStateRegionsAPI: getStateRegions,
        getStateToStateMappingAPI: getStateToStateMapping,
        getProductListVendorDashboardAPI: getProductListVendorDashboard,
        getProductCategorycorporateAPI: getProductCategorycorporate,
        saveProductFeedbackAPI: saveProductFeedback,
        getVendorMonthsFilterAPI: getVendorMonthsFilter,
        tabTrackingAPI: tabTracking,
        getMemberPurchasesDataaAPI: getMemberPurchasesDataa,
        getMemberListAPI: getMemberList,
        getMemberVendorDateAPI:getMemberVendorDate

    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(VendorDashboard);
